import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import RemoveIcon from "@mui/icons-material/Remove";
import TuneIcon from "@mui/icons-material/Tune";
import {
  Box,
  Collapse,
  Container,
  FormHelperText,
  Grid,
  IconButton,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import { uniq } from "lodash";
import moment from "moment";
import { Fragment, useEffect, useMemo, useState } from "react";
import { flushSync } from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import Custom3dotString from "../../../components/Custom3dotString";
import CustomButton from "../../../components/CustomButton";
import CustomCheckbox from "../../../components/CustomCheckbox";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../components/CustomTextField";
import CustomUpload from "../../../components/CustomUpload";
import { default as Select } from "../../../components/Select/Select";
import SplitButton from "../../../components/SplitButtion";
import { soapApi } from "../../../redux/actions/api";
import {
  createStocks,
  createStocksForPending,
  getBranchesDataSharing,
  getClinicRoles,
  getClinicStocksWoLoader,
  getClinicUsers,
  getLocations,
  getPendingStocksByClinic,
  getStocksByClinicByFilter,
  getSupplier,
  updateBulkPriceForStock,
  updateStockAdjust,
  updateStockWithBatchList,
} from "../../../redux/reducers/clinicSlice";
import { hideLoader, showLoader } from "../../../redux/reducers/loaderSlice";
import { AppColors } from "../../../util/AppColors";
import {
  drugScheduleShowCategoryList,
  StockAdjustList,
} from "../../../util/arrayList";
import { addIcon, plusBtn } from "../../../util/CommonIconStyle";
import {
  administeredUOMList,
  discountTypes,
  dosageTypes,
  drugScheduleList,
  incDecList,
  productCategoryList,
  purchaseTypes,
} from "../../../util/dropList";
import {
  getExactNumber,
  getTotalValues,
  normalizeDate,
} from "../../../util/function";
import { patchMandateSession } from "../../../util/mandateSessionStorage";
import { tblGrayBack } from "../../../util/object";
import FilesWithCloseButton from "../ClinicPetDetails/PatientWorkbook/FilesWithCloseButton";
import StockPendingTable from "./StockPendingTable";

const objMatch = {
  Subcategory: "subCategory",
  "HSN Code": "hsnSacCode",
  Brand: "brand",
  Nature: "nature",
  "Batch Number": "batchNo",
  "Purchase UOM": "purchaseUom",
  "Sales UOM": "salesUom",
};

const tableHeaders = [
  "productName",
  "tradeName",
  "category",
  "subUnitQty",
  "status",
];

const options = [
  "Create Stock",
  "Create Purchase",
  "Adjust",
  "Bulk Price Update",
];

const nameExpan = {
  supplierName: "Supplier Name",
  category: "Category",
  status: "Status",
  tradeName: "Trade Name",
  productName: "Product Name",
  batchNo: "Batch No",
  quantity: "Quantity",
  updatedQuantity: "Updated Quantity",
  location: "Location",
  productCode: "Product Code",
  unitType: "Unit Type",
  extraStatus: "",
  purchaseCost: "Purchase Cost",

  type: "Type",
  product: "Product",
  supplier: "Supplier",
  batchNumber: "Batch Number",
  remarks: "Remarks",
  customer: "Customer",
  invoiceNumber: "Invoice Number",
  subUnitQty: "Subunit Qty",
};

const initStckVal = {
  supplierName: "",
  date: null,
  invoiceNumber: "",
  list: [],
  purchaseType: { name: "Intrastate", value: "Intrastate" },
};
const initObj = {
  hsnSacCode: "",
  name: "",
  quantity: "1",
  packageUom: "",
  purchaseUom: "",
  gst: 0,
  cgst: 0,
  sgst: 0,
  taxableValue: 0,
  taxes: 0,
  itemTotal: 0,
};

const stckEntTblHdrs = [
  "sno",
  "hsnSacCode",
  "name",
  "quantity",
  "purchaseUom",
  "cgst",
  "sgst",
  "taxableValue",
  "taxes",
  "itemTotal",
  "status",
];
const stckEntIgstTblHdrs = [
  "sno",
  "hsnSacCode",
  "name",
  "quantity",
  "purchaseUom",
  "gst",
  "taxableValue",
  "taxes",
  "itemTotal",
  "status",
];

const stckNmeExpan = {
  icon: "",
  sno: "S No",
  hsnSacCode: "HSN Code",
  name: "Name *",
  quantity: "Qty *",
  cgst: "CGST % *",
  sgst: "SGST % *",
  gst: "IGST % *",
  taxableValue: "Taxable Value *",
  taxes: "Taxes *",
  itemTotal: "Item Total *",
  purchaseUom: "UOM *",
};

const initAdjValues = {
  type: StockAdjustList?.[0],
  batchNumber: null,
  quantity: null,
  remarks: "",
  supplier: null,
  product: null,
  customer: null,
  invoiceNumber: "",
};
const initAdjErrs = {
  type: false,
  batchNumber: false,
  quantity: false,
  remarks: false,
  supplier: false,
  product: false,
  customer: false,
  invoiceNumber: false,
};
const initAdjHlps = {
  type: "",
  batchNumber: "",
  quantity: "",
  remarks: "",
  supplier: "",
  product: "",
  customer: "",
  invoiceNumber: "",
};
const initBatch = {
  batchNumber: "",
  manufacturingDate: null,
  expiryDate: null,
  location: null,
  quantity: "",
  subunits: "",
  unitSellingPrice: "",
  landedCost: "",
};

const requiredFields = [
  "category",
  "subCategory",
  "name",
  "tradeName",
  // "code",
  // "location",
  // "quantity",
  // "subunits",
  // "landedCost",
  "cgst",
  "sgst",
  // "itemTotal",
  // "unitSellingPrice",
];
const stckRequiredFields = ["supplierName", "invoiceNumber"];
const batchRequiredFields = [
  "location",
  "quantity",
  "subunits",
  "unitSellingPrice",
];

const initSearch = { name: "", barCode: "", category: [], location: [] };
const initFilter = {
  visible: false,
  added: false,
  selectedList: [],
  values: {},
};
const filterByList = [
  "Subcategory",
  "HSN Code",
  "Brand",
  "Nature",
  "Batch Number",
  "Mfg Date",
  "Expiry Date",
  "Purchase UOM",
  "Sales UOM",
  "Unit Quantity",
  "Subunit Quantity",
  "Unit Selling Price",
  "Taxes",
  "Landed Cost",
  "Drug Schedule",
  "Reorder Level",
];
const splitRows = [
  "Mfg Date",
  "Expiry Date",
  "Unit Quantity",
  "Subunit Quantity",
  "Unit Selling Price",
  "Taxes",
  "Landed Cost",
];
const inputSuggestionList = [
  "Subcategory",
  "HSN Code",
  "Brand",
  "Nature",
  "Batch Number",
  "Purchase UOM",
  "Sales UOM",
];

const initBulkPrices = {
  type: "Increase",
  valueType: "Price",
  value: "",
  valueErr: "",
};

const Stock = ({ penTblVsble, setPenTblVsble }) => {
  const dispatch = useDispatch();
  const [searchValues, setSearchValues] = useState(initSearch);
  const [searchValue, setSearchValue] = useState("");
  const [filterVal, setFilterVal] = useState("All");
  const [page, setPage] = useState(1);
  const [stcEntModVsble, setStcEntModVsble] = useState(false);
  const [stcEntFiles, setStcEntFiles] = useState([]);
  const [actStep, setActStep] = useState(1);
  const [stckValue, setStckValue] = useState(initStckVal);
  const [adjustModVsble, setAdjustModVsble] = useState(false);
  const [adjustValues, setAdjustValues] = useState(initAdjValues);
  const [adjustErrors, setAdjustErrors] = useState(initAdjErrs);
  const [adjustHelpers, setAdjustHelpers] = useState(initAdjHlps);
  const [productList, setProductList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [submitErr, setSubmitErr] = useState(false);
  const [stockEntrErr, setStockEntErr] = useState(false);
  const [editModVsble, setEditModVsble] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [editValues, setEditValues] = useState({});
  const [editErrs, setEditErrs] = useState({});
  const [editHelps, setEditHelps] = useState({});
  const [stckErrs, setStckErrs] = useState({});
  const [stckHelps, setStckHelps] = useState({});
  const [isListNotValid, setListNotValid] = useState(false);
  const [stockList, setStockList] = useState([]);
  const [batchValues, setBatchValues] = useState({});
  const [batchErrs, setBatchErrs] = useState({});
  const [batchHelps, setBatchHelps] = useState({});
  const [bulkPriceModVsble, setBulkPriceModVsble] = useState(false);
  const [bulkPriceValues, setBulkPriceValues] = useState(initBulkPrices);
  const [isManualEntry, setMaualEntry] = useState(false);
  const [filterValues, setFilterValues] = useState(initFilter);
  const {
    suppliers,
    users,
    clinicRoles,
    stocksByFilter,
    branchesDataSharing,
    locationList,
  } = useSelector((state) => state?.clinic);
  const rowsPerPage = 10;
  const defaultUrl = `?page=1&itemSize=${rowsPerPage}`;
  const user = localStorage.getItem("user");
  const profile = JSON.parse(user);
  const mandateDataRaw = sessionStorage.getItem("mandateData");
  const { stocks: clinicStocks } = useMemo(() => {
    if (!mandateDataRaw) {
      return { stocks: [] };
    }
    try {
      const reqData = JSON.parse(mandateDataRaw);
      return {
        stocks: Array.isArray(reqData?.stocks) ? reqData?.stocks : [],
      };
    } catch {
      return { stocks: [] };
    }
  }, [mandateDataRaw]);

  useEffect(() => {
    //for calling the init api call to load the data
    // onStockApiCall(1, true);
    setFilterValues({ ...initFilter, selectedList: [], values: {} });
    // dispatch(getClinicStocksWoLoader());
    dispatch(getLocations());
    dispatch(getClinicUsers(`?itemSize=30&page=1`));
    dispatch(getClinicRoles());
    dispatch(getBranchesDataSharing());
    dispatch(getSupplier());
  }, []);

  useEffect(() => {
    // const hasSearchValues =
    //   searchValues?.name?.trim() ||
    //   searchValues?.barCode?.trim() ||
    //   (searchValues?.category && searchValues?.category?.length > 0) ||
    //   (searchValues?.location && searchValues?.location?.length > 0);
    // if (hasSearchValues) {
    onStockApiCall(1);
    // }
  }, [
    searchValues?.name,
    searchValues?.barCode,
    searchValues?.category,
    searchValues?.location,
  ]);

  // useEffect(() => {
  //   dispatch(
  //     getStocksByClinic(
  //       `?page=1&itemSize=${rowsPerPage}${
  //         searchValue?.length > 0 ? `&search=${searchValue}` : ""
  //       }`
  //     )
  //   );
  //   setPage(1);
  // }, [searchValue]);

  useEffect(() => {
    if (!stocksByFilter?.data) {
      setStockList([]);
      return setProductList([]);
    }
    const reqList = stocksByFilter?.data?.map((prd) => ({
      name: prd?.tradeName,
      value: prd?.tradeName,
    }));
    setProductList(reqList);
    setStockList(
      stocksByFilter?.data?.map((stc) => ({ ...stc, selected: false })),
    );
  }, [stocksByFilter]);

  useEffect(() => {
    if (users?.length === 0 || !users) return setUserList([]);
    const reqList = users
      ?.filter((usr) => usr?.name?.length > 0)
      ?.map((sup) => ({ name: sup?.name, value: sup?.name, userId: sup?.id }))
      ?.sort((a, b) => a?.name?.localeCompare(b?.name));
    setUserList(reqList);
  }, [users]);

  const getSupplierList = () => {
    const reqList = suppliers?.data
      ?.map((sup) => ({
        name: sup?.supplierName,
        value: sup?.supplierName,
        supplierId: sup?.supplierId,
      }))
      ?.sort((a, b) => a?.name?.localeCompare(b?.name));
    return reqList;
  };

  const getInventoryDataAccess = () => {
    const profileMat = branchesDataSharing?.find(
      (li) => li?.createdBy === profile?.id,
    );
    return (
      (profileMat
        ? profileMat?.inventryData
        : branchesDataSharing?.[0]?.inventryData) ?? false
    );
  };

  const getFilterObj = (currentPage = 1, reset = false) => {
    setPage(currentPage);
    const reqObj = {
      page: currentPage,
      itemSize: rowsPerPage,
      inventryData: getInventoryDataAccess(),
    };
    if (reset) return reqObj;
    if (searchValues?.name?.length > 0) reqObj.productName = searchValues?.name;
    if (searchValues?.barCode?.length > 0)
      reqObj.barcode = searchValues?.barCode;
    if (searchValues?.category?.length > 0)
      reqObj.category = searchValues?.category?.map((li) => li?.value);
    if (searchValues?.location?.length > 0)
      reqObj.location = searchValues?.location?.map((li) => li?.value);

    if (filterValues?.selectedList?.includes("Mfg Date")) {
      reqObj.mfgDateStart = moment(
        new Date(filterValues?.values?.["Mfg Start Date"] ?? new Date()),
      ).format("YYYY-MM-DD");
      reqObj.mfgDateEnd = moment(
        new Date(filterValues?.values?.["Mfg End Date"] ?? new Date()),
      ).format("YYYY-MM-DD");
    }
    if (filterValues?.selectedList?.includes("Expiry Date")) {
      reqObj.expiryDateStart = moment(
        new Date(filterValues?.values?.["Expiry Start Date"] ?? new Date()),
      ).format("YYYY-MM-DD");
      reqObj.expiryDateEnd = moment(
        new Date(filterValues?.values?.["Expiry End Date"] ?? new Date()),
      ).format("YYYY-MM-DD");
    }
    if (filterValues?.selectedList?.includes("Unit Quantity")) {
      reqObj.unitQuantityMin = Number(
        filterValues?.values?.["Min Unit Quantity"] ?? 0,
      );
      reqObj.unitQuantityMax = Number(
        filterValues?.values?.["Max Unit Quantity"] ?? 0,
      );
    }
    if (filterValues?.selectedList?.includes("Subunit Quantity")) {
      reqObj.subunitQuantityMin = Number(
        filterValues?.values?.["Min Subunit Quantity"] ?? 0,
      );
      reqObj.subunitQuantityMax = Number(
        filterValues?.values?.["Max Subunit Quantity"] ?? 0,
      );
    }
    if (filterValues?.selectedList?.includes("Unit Selling Price")) {
      reqObj.unitSellingPriceMin = Number(
        filterValues?.values?.["Min Unit Selling Price"] ?? 0,
      );
      reqObj.unitSellingPriceMax = Number(
        filterValues?.values?.["Max Unit Selling Price"] ?? 0,
      );
    }
    if (filterValues?.selectedList?.includes("Taxes")) {
      reqObj.taxesMin = Number(filterValues?.values?.["Min Tax %"] ?? 0);
      reqObj.taxesMax = Number(filterValues?.values?.["Max Tax %"] ?? 0);
    }
    if (filterValues?.selectedList?.includes("Landed Cost")) {
      reqObj.landedCostMin = Number(
        filterValues?.values?.["Min Landed Cost"] ?? 0,
      );
      reqObj.landedCostMax = Number(
        filterValues?.values?.["Max Landed Cost"] ?? 0,
      );
    }
    if (filterValues?.selectedList?.includes("Subcategory")) {
      reqObj.subCategory = filterValues?.values?.["Subcategory"] ?? "";
    }
    if (filterValues?.selectedList?.includes("HSN Code")) {
      reqObj.hsnCode = filterValues?.values?.["HSN Code"] ?? "";
    }
    if (filterValues?.selectedList?.includes("Brand")) {
      reqObj.brand = filterValues?.values?.["Brand"] ?? "";
    }
    if (filterValues?.selectedList?.includes("Nature")) {
      reqObj.nature = filterValues?.values?.["Nature"] ?? "";
    }
    if (filterValues?.selectedList?.includes("Batch Number")) {
      reqObj.batchNumber = filterValues?.values?.["Batch Number"] ?? "";
    }
    if (filterValues?.selectedList?.includes("Purchase UOM")) {
      reqObj.purchaseUom = filterValues?.values?.["Purchase UOM"] ?? "";
    }
    if (filterValues?.selectedList?.includes("Sales UOM")) {
      reqObj.salesUom = filterValues?.values?.["Sales UOM"] ?? "";
    }
    if (
      filterValues?.selectedList?.includes("Drug Schedule") &&
      filterValues?.values?.["Drug Schedule"]?.value?.length > 0
    ) {
      reqObj.drugSchedule =
        filterValues?.values?.["Drug Schedule"]?.value ?? null;
    }
    if (
      filterValues?.selectedList?.includes("Reorder Level") &&
      filterValues?.values?.["Reorder Level"]?.length > 0
    ) {
      reqObj.reorderLevel = filterValues?.values?.["Reorder Level"] ?? "";
    }
    return reqObj;
  };

  const onStockApiCall = (currentPage = 1, reset = false) => {
    dispatch(getStocksByClinicByFilter(getFilterObj(currentPage, reset)));
  };

  const getSuggestionList = (typ = null) => {
    if (!typ) return [];
    const valMatch = objMatch?.[typ];
    if (
      valMatch === "subCategory" ||
      valMatch === "hsnSacCode" ||
      valMatch === "brand" ||
      valMatch === "nature"
    ) {
      const reqList = clinicStocks?.map((ser) => ser?.[valMatch] ?? "") ?? [];
      const uniqList = uniq(reqList ?? []);
      return uniqList ?? [];
    }
    const reqList = clinicStocks?.flatMap((stk) => {
      return stk?.stockBatch?.map((bat) => bat?.[valMatch] ?? "");
    });
    const uniqList = uniq(reqList ?? []);
    return uniqList ?? [];
  };

  const handleSearch = (e) => {
    setSearchValue(e.target.value);
    setPage(1);
  };

  const handleCreateUpdate = () => {
    setStcEntModVsble(true);
  };

  const getLocationList = () => {
    if (locationList?.length === 0 || !locationList) return [];
    return locationList?.map((loc) => ({
      name: loc?.locationName,
      value: loc?.locationName,
      id: loc?.id,
    }));
  };

  const getDepartmentList = () => {
    const list = clinicRoles
      ?.filter((li) => li?.type?.toLowerCase() === "department")
      ?.map((li) => ({
        name: li?.roleName,
        value: li?.roleName,
        id: li?.roleId,
      }));
    return [{ name: "All", value: "All", id: "all" }, ...(list ?? [])];
  };

  const handleEditStock = (itm) => {
    setSelectedItem(itm);
    const reqBatch = (itm?.stockBatch ?? itm?.batches)?.[0];
    const reqLocation = locationList?.find(
      (loc) => loc?.id === reqBatch?.locationId,
    );
    const reqBatchList = (itm?.stockBatch ?? [])?.map((bat, i) => {
      const batLoc = locationList?.find((loc) => loc?.id === bat?.locationId);
      const obj = {
        i,
        batchNumber: bat?.batchNo,
        batchId: bat?.batchId,
        manufacturingDate: bat?.mfgDate ?? null,
        expiryDate: bat?.expiryDate ?? null,
        location: {
          name: batLoc?.locationName,
          value: batLoc?.locationName,
          id: batLoc?.id ?? bat?.locationId,
        },
        quantity: bat?.quantity,
        subunits: bat?.subunits,
        unitSellingPrice: Number(bat?.unitSellingPrice)?.toFixed(2),
        landedCost: bat?.landedCost,
        createdBy: bat?.createdBy,
      };
      return obj;
    });
    const reqObj = {
      ...editValues,
      skuId: itm?.skuId ?? "",
      isBatchEdit: false,
      batchList: reqBatchList,
      active: itm?.active === "Y",
      autoConsumed: itm?.autoConsumed ?? false,
      billable: itm?.billable,
      category: productCategoryList?.find(
        (cat) => cat?.value === itm?.category,
      ),
      subCategory: itm?.subCategory,
      hsnSacCode: itm?.hsnSacCode,
      uqcCode: itm?.uqcCode ?? "",
      name: itm?.productName,
      tradeName: itm?.tradeName,
      ingredient: itm?.activeIngredient,
      nature: itm?.nature,
      code: itm?.barcodeNo,
      // code: reqBatch?.barcodeNo,
      brand: itm?.brand,
      description: itm?.description,
      batchNumber: reqBatch?.batchNo,
      batchId: reqBatch?.batchId,
      manufacturingDate: reqBatch?.mfgDate,
      expiryDate: reqBatch?.expiryDate,
      location: {
        name: reqLocation?.locationName,
        value: reqLocation?.locationName,
        id: reqLocation?.id ?? reqBatch?.locationId,
      },
      purchaseUom: reqBatch?.purchaseUom,
      salesUom: reqBatch?.salesUom,
      conversionFactor: reqBatch?.conversionFactor,
      quantity: reqBatch?.quantity,
      subunits: reqBatch?.subunits,
      cgst: reqBatch?.cgst,
      sgst: reqBatch?.sgst,
      itemTotal: Number(reqBatch?.itemTotal)?.toFixed(2),
      unitSellingPrice: Number(reqBatch?.unitSellingPrice)?.toFixed(2),
      oldSellingPrice: Number(reqBatch?.unitSellingPrice)?.toFixed(2),
      barcodeNo: itm?.barcodeNo,
      // barcodeNo: reqBatch?.barcodeNo,
      landedCost: Number(reqBatch?.landedCost)?.toFixed(2),
      dosage: reqBatch?.dosage ?? "",
      dosageType:
        dosageTypes?.find((li) => li?.value === reqBatch?.dosageType) ??
        dosageTypes?.[0],
      reorderLevel: itm?.reorderLevel ?? "",
      drugSchedule:
        drugScheduleList?.find((cat) => cat?.value === itm?.drugSchedule) ??
        null,
    };
    if (reqBatch?.packageUom) {
      const reqPack = reqBatch?.packageUom?.match(/^(\d+)(.+)/);
      reqObj.packageUom = reqPack?.[1];
      reqObj.adminUom = administeredUOMList?.find(
        (li) => li?.value === reqPack?.[2],
      );
    }
    setEditValues(reqObj);
    setEditModVsble(true);
  };

  const handleCloseStcEnt = () => {
    setStcEntModVsble(false);
    setStckValue(initStckVal);
    setStcEntFiles([]);
    setActStep(1);
    setSubmitErr(false);
    setStockEntErr(false);
    setListNotValid(false);
  };

  const onEntFileUpload = (e) => {
    const fileList = e?.target?.files;
    let fileLists = stcEntFiles?.length > 0 ? [...stcEntFiles] : [];

    const readFiles = Array.from(fileList).map((file, i) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          fileLists = [
            ...fileLists,
            {
              file: file,
              previewUrl: reader.result,
              i,
            },
          ];
          resolve();
        };
        reader.onerror = () => reject(reader.error);
        reader.readAsDataURL(file);
      });
    });

    Promise.all(readFiles)
      .then(() => {
        setStcEntFiles(fileLists);
        setListNotValid(fileLists?.length > 0 ? false : true);
      })
      .catch((error) => console.error("Error reading files: ", error));
  };

  const handleImageRemove = (ind) => {
    const reqList = stcEntFiles
      ?.filter((fle, i) => i !== ind)
      ?.map((fle, i) => ({ ...fle, i }));
    setStcEntFiles(reqList);
    setListNotValid(reqList?.length > 0 ? false : true);
  };

  const onStcEntUpload = async () => {
    if (stcEntFiles?.length === 0 || !stcEntFiles) return setListNotValid(true);
    dispatch(showLoader());
    const form = new FormData();
    stcEntFiles?.forEach((fle) => {
      form.append("files", fle?.file);
    });

    try {
      const apiRes = await soapApi.post("/purchase", form);
      if (apiRes?.status === 200) {
        const reqDta = apiRes?.data;
        const reqList = reqDta?.Items?.map((itm, i) => {
          const reqCgst =
            reqDta?.Purchasetype === "Intrastate"
              ? Number(itm?.GST ?? 0) / 2
              : 0;
          const reqSgst =
            reqDta?.Purchasetype === "Intrastate"
              ? Number(itm?.GST ?? 0) / 2
              : 0;
          return {
            ...itm,
            hsnSacCode: itm?.HSNSAC,
            name: itm?.Name,
            quantity: itm?.Quantity,
            cgst: reqCgst,
            sgst: reqSgst,
            gst: Number(itm?.GST ?? 0),
            igst: Number(itm?.GST ?? 0),
            taxes: itm?.Taxes ?? 0,
            itemTotal: itm?.Itemtotal ?? 0,
            landedCost: itm?.landedCost ?? 0,
            purchaseUom: itm?.Purchaseuom,
            taxableValue: itm?.Taxablevalue ?? 0,
            i,
            apiCalled: false,
            apiResponse: null,
          };
        });
        // const reqSupplier = suppliers?.data?.find((sup) => sup?.supplierName?.toLowerCase() === reqDta?.Suppliername?.toLowerCase());
        const reqObj = {
          ...reqDta,
          additionalCharges: getExactNumber(reqDta?.Additionalcharges),
          address: reqDta?.Address,
          billDate:
            reqDta?.Billdate?.length > 0
              ? new Date(normalizeDate(reqDta?.Billdate))
              : new Date(),
          email: reqDta?.Email,
          GSTIN: reqDta?.GSTIN,
          grandtotal: reqDta?.Grandtotal,
          invoiceNumber: reqDta?.Invoicenumber,
          phone: reqDta?.Phone ?? "",
          supplierName: reqDta?.Suppliername,
          //  reqSupplier ? { name: reqSupplier?.supplierName, value: reqSupplier?.supplierName, supplierId: reqSupplier?.supplierId } : null,          ,
          totaltaxablevalue: reqDta?.Totaltaxablevalue ?? 0,
          totalTaxes: reqDta?.Totaltaxes ?? 0,
          list: reqList,
          purchaseType: {
            name: reqDta?.Purchasetype,
            value: reqDta?.Purchasetype,
          },
        };
        setStcEntFiles([]);
        setStckValue(reqObj);
        setActStep(2);
        setStockEntErr(false);
        dispatch(hideLoader());
      } else {
        dispatch(hideLoader());
      }
    } catch (err) {
      console.log("err", err);
      dispatch(hideLoader());
    }
  };

  const handleChangeStckValue = (name, value) => {
    const reqObj = { ...stckValue, [name]: value };
    const reqValue = typeof value === "object" ? value?.value : value;
    const reqErrs = {
      ...stckErrs,
      [name]:
        reqValue?.length > 0
          ? false
          : stckRequiredFields?.includes(name)
            ? true
            : false,
    };

    const reqHelps = {
      ...stckHelps,
      [name]:
        reqValue?.length > 0
          ? ""
          : stckRequiredFields?.includes(name)
            ? "This is required field"
            : "",
    };
    if (name === "billDate") {
      if (value === null) {
        reqErrs[name] = true;
        reqHelps[name] = "This is required field";
      } else {
        reqErrs[name] = false;
        reqHelps[name] = "";
      }
    }
    if (name === "purchaseType") {
      reqObj.list = stckValue?.list?.map((li) => {
        const obj = {
          ...li,
          cgst:
            value?.value === "Intrastate"
              ? Number(li?.gst ?? li?.igst ?? 0) / 2
              : 0,
          sgst:
            value?.value === "Intrastate"
              ? Number(li?.gst ?? li?.igst ?? 0) / 2
              : 0,
          igst:
            value?.value === "Interstate"
              ? Number(li?.gst ?? li?.igst ?? 0)
              : 0,
        };
        if (value?.value === "Exempt") {
          obj.taxes = 0;
          obj.itemTotal = Number(li?.taxableValue) * Number(li?.quantity);
        }
        if (value?.value !== "Exempt") {
          const reqTaxes = Number(li?.taxableValue) * (li?.gst / 100);
          obj.taxes = reqTaxes * (li?.quantity ?? 0);
          obj.itemTotal =
            (Number(li?.taxableValue) + Number(reqTaxes)) * (li?.quantity ?? 0);
        }
        return obj;
      });
    }
    setStckValue(reqObj);
    setStckHelps(reqHelps);
    setStckErrs(reqErrs);
  };

  const handleChangeTableValue = (name, value, ind) => {
    const purchaseType = stckValue?.purchaseType?.value;

    const reqList = stckValue?.list?.map((li, i) => {
      if (i === ind) {
        const reqObj = {
          ...li,
          [name]: value,
          errors: { ...(li.errors || {}), [name]: undefined },
        };
        const errors = { ...(li.errors || {}) };
        switch (name) {
          case "name":
            if (!value || value.trim() === "") {
              errors.name = "Product name is required";
            } else {
              delete errors.name;
            }
            break;

          case "quantity":
            if (!value || Number(value) <= 0) {
              errors.quantity = "Quantity must be greater than 0";
            } else {
              delete errors.quantity;
            }
            break;

          case "purchaseUom":
            if (!value || value.trim() === "") {
              errors.purchaseUom = "UOM is required";
            } else {
              delete errors.purchaseUom;
            }
            break;

          case "gst":
            if (
              purchaseType === "Interstate" &&
              (!value || Number(value) < 0)
            ) {
              errors.gst = "GST must be 0 or positive";
            } else {
              delete errors.gst;
            }
            break;

          case "cgst":
          case "sgst":
            if (
              purchaseType !== "Interstate" &&
              (!value || Number(value) < 0)
            ) {
              errors[name] = `${name.toUpperCase()} must be 0 or positive`;
            } else {
              delete errors[name];
            }
            break;

          case "taxableValue":
            if (!value || Number(value) <= 0) {
              errors.taxableValue = "Taxable value must be positive";
            } else {
              delete errors.taxableValue;
            }
            break;

          case "itemTotal":
            if (!value || Number(value) <= 0) {
              errors.itemTotal = "Item total must be positive";
            } else {
              delete errors.itemTotal;
            }
            break;

          default:
            break;
        }
        if (
          name === "taxableValue" ||
          name === "sgst" ||
          name === "cgst" ||
          name === "gst"
        ) {
          if (name === "sgst" || name === "cgst") {
            reqObj.cgst = value;
            reqObj.sgst = value;
            reqObj.gst = Number(value) * 2;
          }
          if (name === "gst") {
            reqObj.cgst = Number(value) / 2;
            reqObj.sgst = Number(value) / 2;
            reqObj.gst = value;
          }
          const reqTaxableValue =
            name === "taxableValue" ? Number(value) : Number(li?.taxableValue);
          const taxPercent =
            stckValue?.purchaseType?.value === "Interstate"
              ? Number(name === "gst" ? value : li?.gst)
              : Number(name === "cgst" || name === "sgst" ? value : li?.cgst) +
                Number(name === "sgst" || name === "cgst" ? value : li?.sgst);
          const reqTaxes = Number(reqTaxableValue * (taxPercent / 100));
          reqObj.taxes = reqTaxes;
          reqObj.itemTotal = Number(reqTaxableValue) + Number(reqTaxes);
        }
        if (name === "itemTotal") {
          const reqPer = (100 + Number(li?.gst)) / 100;
          const reqTaxableValue = Number(
            Number(value) / Number(reqPer),
          )?.toFixed(2);
          reqObj.taxes = Number(value) - reqTaxableValue;
          reqObj.taxableValue = reqTaxableValue;
        }
        return { ...reqObj, errors };
      }
      return li;
    });
    setStckValue({ ...stckValue, list: reqList });
  };

  const handleChangeAdditionalCharge = (name, value) => {
    setStckValue({ ...stckValue, [name]: value });
  };

  const handleDeleteRow = (ind) => {
    const reqList = stckValue?.list
      ?.filter((li, i) => i !== ind)
      ?.map((li, i) => ({ ...li, i }));
    setStckValue({ ...stckValue, list: reqList });
    setListNotValid(reqList?.length > 0 ? false : true);
  };

  const handleChangeCheckBox = (value, ind) => {
    const reqList = stockList?.map((stc, i) => {
      if (i === ind) {
        return { ...stc, selected: value };
      }
      return stc;
    });
    setStockList(reqList);
  };

  const TableDataRow = ({ data, ind }) => {
    const [open, setOpen] = useState(false);

    return (
      <Fragment>
        <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
          <TableCell style={{ width: 50 }}>
            <div className="flex-row-ali-cen">
              {/* <CustomCheckbox
                checked={data?.selected}
                onChange={() => handleChangeCheckBox(!data?.selected, ind)}
              /> */}

              <IconButton
                aria-label="expand row"
                size="small"
                onClick={() => setOpen(!open)}
                className="mlMin15"
              >
                {open ? (
                  <RemoveIcon sx={{ color: AppColors.yellowBtn }} />
                ) : (
                  <AddIcon sx={{ color: AppColors.appPrimary }} />
                )}
              </IconButton>
            </div>
          </TableCell>
          {tableHeaders?.map((th) => {
            return (
              <TableCell className="fs14 font-medium">
                {th === "productName" ? (
                  <div
                    className="cursor blue-color underline fs14 font-bold"
                    onClick={() => handleEditStock(data)}
                  >
                    {data?.[th]}
                  </div>
                ) : th === "status" ? (
                  <div style={{ width: 80 }}>
                    {data?.active === "Y" ? (
                      <Typography className="green4 grn-bck status-card fs12 font-medium">
                        Active
                      </Typography>
                    ) : (
                      <Typography className="red11 red-back status-card fs12 font-medium">
                        Inactive
                      </Typography>
                    )}
                  </div>
                ) : th === "subUnitQty" ? (
                  (data?.stockBatch ?? data?.batches)?.reduce(
                    (acc, obj) => acc + obj?.subunits,
                    0,
                  )
                ) : th === "uom" ? (
                  (data?.stockBatch ?? data?.batches)?.[0]?.salesUom
                ) : (
                  data?.[th]
                )}
              </TableCell>
            );
          })}
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box style={{ background: "#D9D9D933" }}>
                <div className="ph20pv10 flex-row flex-row-wrap">
                  {(data?.stockBatch ?? data?.batches)?.length > 0 &&
                    (data?.stockBatch ?? data?.batches)?.map((li, i) => (
                      <div
                        className="w33Per flex-row mv10"
                        key={li?.batchId + `${i}`}
                      >
                        <div>
                          <Typography className="font-medium fs12 blue-color">
                            Batch No: {li?.batchNo}
                          </Typography>
                          <Typography className="font-medium fs12 black11">
                            Mfg Date: :{" "}
                            {moment(new Date(li?.mfgDate)).format("YYYY-MM-DD")}
                          </Typography>
                          <Typography className="font-medium fs12 black11">
                            Expiry Date:{" "}
                            {moment(new Date(li?.expiryDate)).format(
                              "YYYY-MM-DD",
                            )}
                          </Typography>
                          <Typography className="font-medium fs12 black11">
                            Unit Qty: {li?.quantity} (Subunits:{" "}
                            {li?.subunits ?? 0})
                          </Typography>
                          <Typography className="font-medium fs12 black11">
                            UOM: {li?.salesUom}
                          </Typography>
                          <Typography className="font-medium fs12 black11">
                            Unit Selling Price: {li?.unitSellingPrice}
                          </Typography>
                          <Typography className="font-medium fs12 black11">
                            Location: {li?.location}
                          </Typography>
                        </div>
                      </div>
                    ))}
                </div>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </Fragment>
    );
  };

  const handleValidate = () => {
    return stckValue?.list?.filter((li) => {
      const nameEmpty = li?.name?.length === 0 || li?.name === "" || !li?.name;
      const noQty = Number(li?.quantity) < 1 || !Number(li?.quantity);
      const uomEmpty =
        li?.purchaseUom?.length === 0 ||
        li?.purchaseUom === "" ||
        !li?.purchaseUom;
      const noCgst = Number(li?.cgst) < 0;
      const noSgst = Number(li?.sgst) < 0;
      const totalEmpty =
        Number(li?.itemTotal) < 0 || !li?.itemTotal || li?.itemTotal === "";
      return nameEmpty || noQty || uomEmpty || noCgst || noSgst || totalEmpty;
    });
  };

  const handleManualValidationCheck = () => {
    let hlpLi = {},
      errLi = {};
    if (
      (stckValue?.supplierName === null || stckValue?.supplierName?.length) ===
      0
    ) {
      errLi["supplierName"] = true;
      hlpLi["supplierName"] = "This field is required field";
    }
    if (
      stckValue?.invoiceNumber === null ||
      stckValue?.invoiceNumber?.length === 0
    ) {
      errLi["invoiceNumber"] = true;
      hlpLi["invoiceNumber"] = "This field is required field";
    }
    if (stckValue?.billDate === null || stckValue?.billDate === undefined) {
      errLi = {
        ...errLi,
        billDate: true,
      };
      hlpLi = {
        ...hlpLi,
        billDate: "This field is required field",
      };
    }

    setStckHelps({ ...stckHelps, ...hlpLi });
    setStckErrs({ ...stckErrs, ...errLi });
    return Object.values(errLi).some((item) => item);
  };

  const onStcApiCall = () => {
    if (handleManualValidationCheck()) return;
    if (stckValue?.list?.length === 0 || !stckValue?.list) {
      return setListNotValid(true);
    } else {
      setListNotValid(false);
    }
    const listErrors = validateStockList(
      stckValue.list,
      stckValue.purchaseType?.value,
    );
    // Validate stock list

    if (listErrors.length > 0) {
      // Update state to show errors
      const updatedList = stckValue.list.map((item, index) => ({
        ...item,
        errors: listErrors[index] || {},
      }));
      setStckValue({ ...stckValue, list: updatedList });
      return setListNotValid(true);
    }

    if (handleValidate()?.length > 0 || !stckValue?.purchaseType) {
      return setListNotValid(true);
    } else {
      setListNotValid(false);
    }
    dispatch(showLoader());
    let stocks = [];
    if (stckValue?.list?.length > 0) {
      stocks = stckValue?.list?.map((itm) => {
        return {
          skuId: "",
          purchaseUom: itm?.purchaseUom ?? itm?.Purchaseuom,
          hsnSacCode: itm?.hsnSacCode ?? itm?.HSNSAC,
          tradeName: itm?.name ?? itm?.Name,
          quantity: Number(getExactNumber(itm?.quantity)) ?? 1,
          cgst:
            stckValue?.purchaseType?.value === "Intrastate"
              ? Number(Number(itm?.gst ?? itm?.igst ?? 0) / 2)
              : 0,
          sgst:
            stckValue?.purchaseType?.value === "Intrastate"
              ? Number(Number(itm?.gst ?? itm?.igst ?? 0) / 2)
              : 0,
          igst:
            stckValue?.purchaseType?.value === "Interstate"
              ? Number(itm?.igst ?? 0)
              : 0,
          taxes: Number(itm?.taxes) ?? 0,
          taxableValue: Number(itm?.taxableValue) ?? 0,
          itemTotal: Number(itm?.itemTotal) ?? 0,
          landedCost:
            Number(
              (Number(itm?.itemTotal) ?? 0) /
                (Number(getExactNumber(itm?.quantity)) ?? 1),
            ) ?? 0,
          status: false,
          product: null,
          dosage: itm?.dosage ?? "",
          dosageType: itm?.dosageType?.value ?? null,
        };
      });
    }
    const data = {
      supplierName: stckValue?.supplierName?.toString() ?? "",
      date: moment().format("YYYY-MM-DD"),
      email: stckValue?.email ?? "",
      phone: stckValue?.phone,
      address: stckValue?.address ?? "",
      gstNumber: stckValue?.GSTIN ?? "",
      billDate: moment(new Date(stckValue?.billDate)).format("YYYY-MM-DD"),
      invoiceNumber: stckValue?.invoiceNumber,
      totalTaxableValue:
        getTotalValues({
          list: stckValue?.list,
          additionalCharges: stckValue?.additionalCharges,
        })?.taxableValues ?? 0,
      totalTaxes:
        getTotalValues({
          list: stckValue?.list,
          additionalCharges: stckValue?.additionalCharges,
        })?.taxes ?? 0,
      additionalCharges: Number(stckValue?.additionalCharges) ?? 0,
      grandTotal: Number(
        getTotalValues({
          list: stckValue?.list,
          additionalCharges: stckValue?.additionalCharges,
        })?.grandTotal,
      ),
      purchaseType: stckValue?.purchaseType?.value,
      stocks,
    };
    try {
      dispatch(createStocksForPending(data)).then((res) => {
        if (res?.payload) {
          onStockApiCall(1);
          // dispatch(getStocksByClinic(defaultUrl));
          dispatch(getPendingStocksByClinic(`?type=pending`));
          setStcEntModVsble(false);
          setStckValue(initStckVal);
          setStckErrs({});
          setStckHelps({});
          setActStep(1);
          setSubmitErr(false);
        }
      });
    } catch (err) {
      dispatch(hideLoader());
      console.log("Err");
    }
  };

  const handleAdjust = () => {
    setAdjustModVsble(true);
  };

  const handleCloseAdjMod = () => {
    setAdjustModVsble(false);
    setAdjustValues(initAdjValues);
    setAdjustErrors(initAdjErrs);
    setAdjustHelpers(initAdjHlps);
  };

  const handleChangeAdjustValue = (name, value) => {
    const reqValue = typeof value === "object" ? value?.value : value;
    // if (name === "type" && value?.value === "Return on Purchase") {
    //   dispatch(getSupplier());
    // }
    setAdjustValues({ ...adjustValues, [name]: value });
    setAdjustErrors({
      ...adjustErrors,
      [name]:
        reqValue?.length > 0
          ? false
          : adjustValues?.type?.value !== "Other Adjustments" &&
              name === "remarks"
            ? false
            : name === "invoiceNumber"
              ? false
              : true,
    });
    setAdjustHelpers({
      ...adjustHelpers,
      [name]:
        reqValue?.length > 0
          ? ""
          : adjustValues?.type?.value !== "Other Adjustments" &&
              name === "remarks"
            ? ""
            : name === "invoiceNumber"
              ? ""
              : `${nameExpan[name]} is Required`,
    });
  };

  const getBatchNumbersByProduct = (tradeName) => {
    const reqPrd = stocksByFilter?.data?.find(
      (stc) => stc?.tradeName?.toLowerCase() === tradeName?.toLowerCase(),
    );
    if (reqPrd) {
      const reqList = (reqPrd?.stockBatch ?? reqPrd?.batches)?.map((btc) => ({
        name: btc?.batchNo,
        value: btc?.batchNo,
      }));
      return reqList;
    }
    return [];
  };

  const handleValidation = () => {
    const errList = {};
    const hlpList = {};
    Object.keys(adjustValues).forEach(function (key) {
      const reqValue =
        typeof adjustValues[key] === "object"
          ? (adjustValues[key]?.value ?? null)
          : adjustValues[key];
      if (
        key === "quantity" &&
        adjustValues?.type?.value !== "Other Adjustments" &&
        Number(reqValue) < 1
      ) {
        errList[key] = true;
        hlpList[key] = "Quantity must be Positive number";
        return;
      }
      if (reqValue?.length === 0 || reqValue === null) {
        if (key === "invoiceNumber") {
          errList[key] = false;
          hlpList[key] = "";
          return;
        }
        if (
          key === "remarks" &&
          adjustValues?.type?.value !== "Other Adjustments"
        ) {
          errList[key] = false;
          hlpList[key] = "";
          return;
        }
        if (
          key === "supplier" &&
          adjustValues?.type?.value !== "Return on Purchase"
        ) {
          errList[key] = false;
          hlpList[key] = "";
          return;
        }
        if (
          key === "customer" &&
          adjustValues?.type?.value !== "Return on Sales"
        ) {
          errList[key] = false;
          hlpList[key] = "";
          return;
        }
        errList[key] = true;
        hlpList[key] = `${nameExpan[key]} is Required`;
      }
    });
    setAdjustHelpers({ ...adjustHelpers, ...hlpList });
    setAdjustErrors({ ...adjustErrors, ...errList });
    return Object.values(errList).some((item) => item);
  };

  const handleStockAdjust = () => {
    const validation = handleValidation();
    if (validation) return;
    const data = {
      type: adjustValues?.type?.value,
      quantity:
        adjustValues?.type?.value === "Return on Purchase"
          ? Number(adjustValues?.quantity) * -1
          : Number(adjustValues?.quantity),
      batchNumber: adjustValues?.batchNumber?.value,
      productName: adjustValues?.product?.value,
      remarks: adjustValues?.remarks,
    };
    if (adjustValues?.type?.value !== "Other Adjustments") {
      data.invoiceNumber = adjustValues?.invoiceNumber;
    }
    if (adjustValues?.type?.value === "Return on Purchase") {
      data.supplierName = adjustValues?.supplier?.name;
      data.supplierId = adjustValues?.supplier?.supplierId;
    }
    if (adjustValues?.type?.value === "Return on Sales") {
      data.customerName = adjustValues?.customer?.name;
      data.userId = adjustValues?.customer?.userId;
    }
    dispatch(updateStockAdjust(data)).then((res) => {
      if (res?.payload) {
        onStockApiCall(1);
        // dispatch(getStocksByClinic(defaultUrl));
        handleCloseAdjMod();
      }
    });
  };

  const handleAdd = () => {
    const reqList = [
      ...stckValue?.list,
      {
        ...initObj,
        i: stckValue?.list?.length,
        apiCalled: false,
        apiResponse: null,
      },
    ];
    setStckValue({ ...stckValue, list: reqList });
    setListNotValid(reqList?.length > 0 ? false : true);
  };

  const totalPage = Math.ceil(stocksByFilter?.totalRecords / rowsPerPage);

  const handleChangePage = (e, selectedPage) => {
    onStockApiCall(selectedPage);
    // dispatch(
    //   getStocksByClinic(
    //     `?page=${selectedPage}&itemSize=${rowsPerPage}&search=${searchValue}`
    //   )
    // );
    // setPage(selectedPage);
  };

  const onCloseEditMod = () => {
    setEditModVsble(false);
    setSelectedItem(null);
    setMaualEntry(false);
    setEditValues({});
    setEditHelps({});
    setEditErrs({});
    setBatchValues({});
    setBatchErrs({});
    setBatchHelps({});
  };

  const handleChange = (name, value, addObj) => {
    let reqObj = { ...editValues, [name]: value };
    const reqValue = typeof value === "object" ? value?.value : value;
    if (name === "batchNumber") reqObj.batchId = addObj?.batchId;
    if (name === "sgst" || name === "cgst") {
      reqObj.cgst = value;
      reqObj.sgst = value;
      reqObj.gst = Number(value) * 2;
      reqObj.igst = Number(value) * 2;
    }
    if (name === "conversionFactor") {
      reqObj.subunits = Number(value) * Number(editValues?.quantity);
      // reqObj.unitSellingPrice =
      //   Number(reqObj?.oldSellingPrice ?? reqObj?.unitSellingPrice ?? 0) /
      //   Number(value);
      if (!selectedItem) {
        reqObj.landedCost =
          Number(editValues?.itemTotal ?? 0) /
          (Number(value ?? 0) * Number(editValues?.quantity ?? 0));
      }
    }
    if (name === "quantity") {
      reqObj.subunits = Number(editValues?.conversionFactor) * Number(value);
      // reqObj.unitSellingPrice =
      //   Number(reqObj?.oldSellingPrice ?? reqObj?.unitSellingPrice ?? 0) /
      //   Number(value);
      if (!selectedItem) {
        reqObj.landedCost =
          Number(editValues?.itemTotal ?? 0) /
          (Number(editValues?.conversionFactor ?? 0) * Number(value ?? 0));
      }
    }
    if (name === "unitSellingPrice") {
      reqObj.oldSellingPrice = value;
    }
    if (name === "batchNumber") {
      if (value?.value || addObj?.batchId) {
        const reqBatch = stocksByFilter?.data
          ?.find((stc) => stc?.stockId === selectedItem?.stockId)
          ?.[
            "stockBatch" || "batches"
          ]?.find((bat) => bat?.batchId === value?.value || addObj?.batchId);
        const reqLocation = locationList?.find(
          (loc) => loc?.id === reqBatch?.locationId,
        );
        reqObj = {
          ...reqObj,
          // code: reqBatch?.barcodeNo,
          batchNumber: reqBatch?.batchNo,
          // { name: reqBatch?.batchNo, value: reqBatch?.batchId },
          manufacturingDate: reqBatch?.mfgDate,
          expiryDate: reqBatch?.expiryDate,
          location: {
            name: reqLocation?.locationName,
            value: reqLocation?.locationName,
            id: reqLocation?.id ?? reqBatch?.locationId,
          },
          purchaseUom: reqBatch?.purchaseUom ?? "",
          salesUom: reqBatch?.salesUom ?? "",
          conversionFactor: reqBatch?.conversionFactor,
          quantity: reqBatch?.quantity,
          subunits: reqBatch?.subunits,
          cgst: reqBatch?.cgst,
          sgst: reqBatch?.sgst,
          itemTotal: reqBatch?.itemTotal,
          unitSellingPrice: reqBatch?.unitSellingPrice,
          oldSellingPrice: reqBatch?.unitSellingPrice,
          // barcodeNo: reqBatch?.barcodeNo,
        };
        if (reqBatch?.batchId) reqObj.batchId = reqBatch?.batchId;
      }
    }
    setEditValues(reqObj);
    const reqErrs = {
      ...editErrs,
      [name]:
        reqValue?.length > 0
          ? false
          : requiredFields?.includes(name)
            ? true
            : false,
    };

    const reqHelps = {
      ...editHelps,
      [name]:
        reqValue?.length > 0
          ? ""
          : requiredFields?.includes(name)
            ? "This is required field"
            : "",
    };
    if (name === "cgst" || name === "sgst") {
      if (reqValue?.length > 0) {
        reqHelps.cgst = "";
        reqHelps.sgst = "";
        reqErrs.cgst = false;
        reqErrs.sgst = false;
      } else {
        reqHelps.cgst = "This is required field";
        reqHelps.sgst = "This is required field";
        reqErrs.cgst = true;
        reqErrs.sgst = true;
      }
    }
    setEditHelps(reqHelps);
    setEditErrs(reqErrs);
  };

  const handleBatchChange = (name, value) => {
    let reqObj = { ...batchValues, [name]: value };
    const reqValue = typeof value === "object" ? value?.value : value;
    if (name === "quantity") {
      reqObj.subunits = Number(editValues?.conversionFactor) * Number(value);
      // if (!selectedItem) {
      reqObj.landedCost =
        Number(editValues?.itemTotal ?? 0) /
        (Number(editValues?.conversionFactor ?? 0) * Number(value ?? 0));
      // }
    }
    if (name === "unitSellingPrice") {
      reqObj.oldSellingPrice = value;
    }
    setBatchValues(reqObj);
    const reqErrs = {
      ...batchErrs,
      [name]:
        reqValue?.length > 0
          ? false
          : batchRequiredFields?.includes(name)
            ? true
            : false,
    };

    const reqHelps = {
      ...batchHelps,
      [name]:
        reqValue?.length > 0
          ? ""
          : batchRequiredFields?.includes(name)
            ? "This is required field"
            : "",
    };
    setBatchHelps(reqHelps);
    setBatchErrs(reqErrs);
  };

  const getBatchList = () => {
    if (!selectedItem) return [];
    const filteredBatches = selectedItem?.["stockBatch" || "batches"]?.map(
      (btch) => ({
        name: btch?.batchNo,
        value: btch?.batchNo,
        apiValue: btch?.batchId,
      }),
    );
    return filteredBatches;
  };

  const handleValidationCheck = () => {
    let hlp = {},
      err = {};
    requiredFields?.forEach((fld) => {
      const reqValue =
        typeof editValues?.[fld] === "object"
          ? editValues?.[fld]?.value
          : editValues?.[fld];
      if (typeof reqValue === "number" ? false : !reqValue) {
        err = {
          ...err,
          [fld]:
            fld === "unitSellingPrice"
              ? editValues?.billable
                ? true
                : false
              : true,
        };
        hlp = {
          ...hlp,
          [fld]:
            fld === "unitSellingPrice"
              ? editValues?.billable
                ? "This is required field"
                : ""
              : "This is required field",
        };
      }
    });
    setEditHelps(hlp);
    setEditErrs(err);
    return Object.values(err).some((item) => item);
  };

  const handleSubmit = () => {
    if (
      handleValidationCheck() ||
      editValues?.batchList?.length === 0 ||
      !editValues?.batchList ||
      typeof editValues?.activeBatchIndex === "number"
    ) {
      if (typeof editValues?.activeBatchIndex === "number") {
        alert("Save or Update the current batch");
      }
      return;
    }
    dispatch(showLoader());
    try {
      if (selectedItem?.stockId && editValues?.batchId) {
        // const subunits =
        //   Number(editValues?.quantity ?? 1) *
        //   Number(editValues?.conversionFactor ?? 1);
        const reqBatchList = editValues?.batchList?.map((bat) => {
          const reqObj = {
            batchId: bat?.batchId ?? null,

            packageUom:
              `${editValues?.packageUom}${editValues?.adminUom?.value}` ?? "",
            dosage: editValues?.dosage ?? "",
            dosageType: editValues?.dosageType?.value ?? null,
            purchaseUom: editValues?.purchaseUom ?? "",
            salesUom: editValues?.salesUom ?? "",
            conversionFactor: editValues?.conversionFactor ?? "1",
            subunits:
              Number(bat?.subunits) ??
              Number(bat?.quantity ?? 1) *
                Number(editValues?.conversionFactor ?? 1),
            quantity: Number(getExactNumber(bat?.quantity) ?? 1),
            // barCodeNo: editValues?.code ?? "",
            description: editValues?.description ?? "",
            batchNumber: bat?.batchNumber,
            brand: editValues?.brand ?? "",
            category: editValues?.category?.value,
            mfgDate: moment(
              new Date(bat?.manufacturingDate ?? new Date()),
            ).format("YYYY-MM-DD"),
            expiryDate: moment(new Date(bat?.expiryDate ?? new Date())).format(
              "YYYY-MM-DD",
            ),
            productName: editValues?.name ?? "",
            hsnSacCode: editValues?.hsnSacCode,
            uqcCode: editValues?.uqcCode ?? "",
            tradeName: editValues?.tradeName,
            ingredient: editValues?.ingredient ?? "",
            nature: editValues?.nature ?? "",
            type: "",
            taxes: 0,
            tax: 0,
            subCategory: editValues?.subCategory ?? "",
            unitSellingPrice: Number(
              getExactNumber(bat?.unitSellingPrice) ?? 0,
            )?.toFixed(2),
            location: bat?.location?.id,
            landedCost: Number(bat?.landedCost ?? 0),
            cgst: Number(getExactNumber(editValues?.cgst) ?? 0),
            sgst: Number(getExactNumber(editValues?.sgst) ?? 0),

            // batchNumber: bat?.batchNumber,
            // quantity: Number(getExactNumber(bat?.quantity) ?? 1),
            // landedCost:
            //   Number(
            //     Number(getExactNumber(editValues?.itemTotal) ?? 0) /
            //       Number(
            //         Number(bat?.quantity ?? 1) *
            //           Number(editValues?.conversionFactor ?? 1)
            //       ) ?? 1
            //   ) ?? Number(bat?.landedCost),
            // mfgDate: moment(
            //   new Date(bat?.manufacturingDate ?? new Date())
            // ).format("YYYY-MM-DD"),
            // expiryDate: moment(new Date(bat?.expiryDate ?? new Date())).format(
            //   "YYYY-MM-DD"
            // ),
            // location: bat?.location?.id,
            // subunits:
            //   Number(bat?.subunits) ??
            //   Number(bat?.quantity ?? 1) *
            //     Number(editValues?.conversionFactor ?? 1),
            // unitSellingPrice: Number(
            //   getExactNumber(bat?.unitSellingPrice) ?? 0
            // ),
          };
          return reqObj;
        });
        const data = {
          multipleBatch: reqBatchList,
          skuId: editValues?.skuId ?? "",
          active: editValues?.active,
          autoConsumed: editValues?.autoConsumed,
          billable: editValues?.billable,
          ingredient: editValues?.ingredient ?? "",
          description: editValues?.description ?? "",
          brand: editValues?.brand ?? "",
          barCodeNo: editValues?.code ?? "",
          productName: editValues?.name ?? "",
          hsnSacCode: editValues?.hsnSacCode,
          uqcCode: editValues?.uqcCode ?? "",
          tradeName: editValues?.tradeName,
          category: editValues?.category?.value,
          subCategory: editValues?.subCategory ?? "",
          // batchNumber: editValues?.batchNumber,
          nature: editValues?.nature ?? "",
          // mfgDate: moment(
          //   new Date(
          //     editValues?.mfgDate ?? editValues?.manufacturingDate ?? new Date()
          //   )
          // ).format("YYYY-MM-DD"),
          // expiryDate: moment(
          //   new Date(
          //     editValues?.expiryDate ?? editValues?.expDate ?? new Date()
          //   )
          // ).format("YYYY-MM-DD"),
          // location: editValues?.location?.id,
          // unitSellingPrice: Number(
          //   getExactNumber(editValues?.unitSellingPrice) ?? 0
          // ),
          packageUom:
            `${editValues?.packageUom}${editValues?.adminUom?.value}` ?? "",
          dosage: editValues?.dosage ?? "",
          dosageType: editValues?.dosageType?.value ?? null,
          purchaseUom: editValues?.purchaseUom ?? "",
          salesUom: editValues?.salesUom ?? "",
          // subunits,
          conversionFactor: editValues?.conversionFactor ?? "1",
          cgst: Number(getExactNumber(editValues?.cgst) ?? 0),
          sgst: Number(getExactNumber(editValues?.sgst) ?? 0),
          itemTotal: Number(getExactNumber(editValues?.itemTotal) ?? 0),
          // quantity: Number(getExactNumber(editValues?.quantity) ?? 1),
          landedCost: Number(editValues?.batchList?.[0]?.landedCost ?? 0),
          reorderLevel: editValues?.reorderLevel ?? "",
          drugSchedule: editValues?.drugSchedule?.value ?? "",
          status: true, //for stock table, if send false to go to the pending table
        };
        dispatch(
          updateStockWithBatchList({ stockId: selectedItem?.stockId, data }),
        ).then((res) => {
          if (res?.payload) {
            onCloseEditMod();
            onStockApiCall(1);
            dispatch(getClinicStocksWoLoader()).then((stcRes) => {
              if (stcRes?.payload) {
                patchMandateSession({
                  stocks: stcRes?.payload?.data ?? [],
                });
              }
            });
          }
        });
      } else {
        const reqBatchList = editValues?.batchList?.map((bat) => {
          const product = {
            packageUom:
              `${editValues?.packageUom}${editValues?.adminUom?.value}` ?? "",
            dosage: editValues?.dosage ?? "",
            dosageType: editValues?.dosageType?.value ?? null,
            purchaseUom: editValues?.purchaseUom ?? "",
            salesUom: editValues?.salesUom ?? "",
            conversionFactor: editValues?.conversionFactor ?? "1",
            subunits:
              Number(bat?.subunits) ??
              Number(bat?.quantity ?? 1) *
                Number(editValues?.conversionFactor ?? 1),
            quantity: Number(getExactNumber(bat?.quantity) ?? 1),
            // barCodeNo: editValues?.code ?? "",
            description: editValues?.description ?? "",
            batchNumber: bat?.batchNumber,
            brand: editValues?.brand ?? "",
            category: editValues?.category?.value,
            mfgDate: moment(
              new Date(bat?.manufacturingDate ?? new Date()),
            ).format("YYYY-MM-DD"),
            expiryDate: moment(new Date(bat?.expiryDate ?? new Date())).format(
              "YYYY-MM-DD",
            ),
            productName: editValues?.name ?? "",
            hsnSacCode: editValues?.hsnSacCode,
            uqcCode: editValues?.uqcCode ?? "",
            tradeName: editValues?.tradeName,
            ingredient: editValues?.ingredient ?? "",
            nature: editValues?.nature ?? "",
            type: "",
            taxes: 0,
            tax: 0,
            subCategory: editValues?.subCategory ?? "",
            unitSellingPrice: Number(
              getExactNumber(bat?.unitSellingPrice) ?? 0,
            )?.toFixed(2),
            location: bat?.location?.id,
            landedCost: Number(bat?.landedCost ?? 0),
          };
          return product;
        });
        const stckObj = {
          description: editValues?.description ?? "",
          barCodeNo: editValues?.code ?? "",
          hsnSacCode: editValues?.hsnSacCode,
          tradeName: editValues?.tradeName,
          quantity: Number(getExactNumber(editValues?.quantity) ?? 1),
          landedCost: Number(editValues?.batchList?.[0]?.landedCost ?? 0),
          cgst: Number(getExactNumber(editValues?.cgst) ?? 0),
          sgst: Number(getExactNumber(editValues?.sgst) ?? 0),
          taxes: 0,
          itemTotal: Number(getExactNumber(editValues?.itemTotal) ?? 0),
          status: true,
          product: reqBatchList,
          active: editValues?.active,
          autoConsumed: editValues?.autoConsumed,
          billable: editValues?.billable,
          reorderLevel: editValues?.reorderLevel ?? "",
          drugSchedule: editValues?.drugSchedule?.value ?? "",
          skuId: editValues?.skuId ?? "",
        };
        const reqObj = { stocks: stckObj };
        dispatch(createStocks(reqObj)).then((res) => {
          if (res?.payload) {
            onCloseEditMod();
            onStockApiCall(1);
            dispatch(getClinicStocksWoLoader()).then((stcRes) => {
              if (stcRes?.payload) {
                patchMandateSession({
                  stocks: stcRes?.payload?.data ?? [],
                });
              }
            });
          }
        });
      }
    } catch (err) {
      dispatch(hideLoader());
    }
  };

  const handleAction = (value) => {
    if (value === "Create Stock") handleAddManualEntry();
    if (value === "Create Purchase") setStcEntModVsble(true);
    if (value === "Adjust") setAdjustModVsble(true);
    if (value === "Bulk Price Update") setBulkPriceModVsble(true);
  };

  const handleAddManualEntry = () => {
    const batchList = [{ ...initBatch, i: editValues?.batchList?.length ?? 0 }];
    setEditValues({
      batchList,
      activeBatchIndex: 0,
      isBatchEdit: true,
      billable: true,
      active: true,
      autoConsumed: false,
      landedCost: "0",
      adminUom: administeredUOMList?.[0],
      category: null,
      dosageType: null,
      location: null,
      drugSchedule: null,
      reorderLevel: "",
    });
    setBatchValues({ ...initBatch });
    setMaualEntry(true);
    setEditModVsble(true);
    setStcEntModVsble(false);
  };

  const handleManualAddEntry = () => {
    setEditValues({ billable: true, landedCost: "0" });
    setMaualEntry(false);
    setEditModVsble(false);
    setActStep(2);
    setStcEntModVsble(true);
  };

  const handleFilter = (val) => {
    setFilterVal(val);
    onStockApiCall(1);
    // dispatch(
    //   getStocksByClinic(
    //     `?page=1&itemSize=${rowsPerPage}${
    //       val !== "All" ? `&search=${val}` : ""
    //     }`
    //   )
    // );
    // setPage(1);
  };

  const validateStockList = (list, purchaseType) => {
    const errors = [];

    list?.forEach((item, index) => {
      const itemErrors = {};

      // Required fields
      if (!item?.name || item?.name?.trim() === "") {
        itemErrors.name = "Product name is required";
      }

      if (!item?.quantity || Number(item?.quantity) <= 0) {
        itemErrors.quantity = "Quantity must be greater than 0";
      }

      if (!item?.purchaseUom || item?.purchaseUom?.trim() === "") {
        itemErrors.purchaseUom = "UOM is required";
      }

      // Tax validation based on purchase type
      if (purchaseType !== "Exempt") {
        if (purchaseType === "Interstate") {
          if (
            item?.gst === undefined ||
            item?.gst === null ||
            item?.gst === "" ||
            Number(item?.gst) < 0
          ) {
            itemErrors.gst = "GST must be 0 or positive";
          }
        } else {
          if (
            item?.cgst === undefined ||
            item?.cgst === null ||
            item?.cgst === "" ||
            Number(item?.cgst) < 0
          ) {
            itemErrors.cgst = "CGST must be 0 or positive";
          }
          if (
            item?.sgst === undefined ||
            item?.sgst === null ||
            item?.sgst === "" ||
            Number(item?.sgst) < 0
          ) {
            itemErrors.sgst = "SGST must be 0 or positive";
          }
        }
      }

      // Validate item total
      if (!item?.itemTotal || Number(item?.itemTotal) <= 0) {
        itemErrors.itemTotal = "Item total must be greater than 0";
      }

      // Validate tax calculations
      const taxableValue = Number(item?.taxableValue) || 0;
      if (taxableValue <= 0) {
        itemErrors.taxableValue = "Taxable value must be greater than 0";
      }

      if (Object.keys(itemErrors).length > 0) {
        errors[index] = itemErrors;
      }
    });

    return errors;
  };

  const onChangeSearch = (e) => {
    const { name, value } = e?.target;
    setSearchValues({
      ...searchValues,
      [name?.trim()?.replace(/,$/, "")]: value, // remove spaces & trailing commas
    });
  };

  const onFilterChange = (name, value) => {
    const reqObj = { ...filterValues, [name]: value };
    setFilterValues(reqObj);
  };

  const onReset = () => {
    flushSync(() => {
      setSearchValues(initSearch);
    });
    flushSync(() => {
      setFilterValues({ ...initFilter, selectedList: [], values: {} });
    });
    onStockApiCall(1, true);
  };

  const onFilterReset = () => {
    const reqObj = {
      ...initFilter,
      visible: true,
      selectedList: [],
      values: {},
    };
    setFilterValues(reqObj);
  };

  const onApplyFilter = () => {
    onStockApiCall(1);
    const reqObj = { ...filterValues, visible: false };
    setFilterValues(reqObj);
  };

  const onSelectFilter = (name) => {
    const reqObj = { ...filterValues };
    let reqList = filterValues?.selectedList;
    if (reqList?.includes(name)) {
      reqList = reqList?.filter((item) => item !== name);
    } else {
      reqList.push(name);
    }
    reqObj.selectedList = reqList;
    setFilterValues(reqObj);
  };

  const onFilterAdd = (value) => {
    const reqObj = { ...filterValues, added: value };
    setFilterValues(reqObj);
  };

  const onFilterValuesChange = (e) => {
    const { name, value } = e?.target;
    const reqValue = {
      ...filterValues?.values,
      [name?.trim()?.replace(/,$/, "")]: value,
    };
    const reqObj = { ...filterValues, values: reqValue };
    setFilterValues(reqObj);
  };

  const onCloseFilter = () => {
    const reqObj = { ...filterValues, visible: false };
    setFilterValues(reqObj);
    // if (filterValues?.selectedList?.length === 0) return;
    // onStockApiCall(1);
  };

  const getFieldName = (name, type) => {
    if (name === "Mfg Date") {
      if (type === "start") {
        return "Mfg Start Date";
      } else {
        return "Mfg End Date";
      }
    }
    if (name === "Expiry Date") {
      if (type === "start") {
        return "Expiry Start Date";
      } else {
        return "Expiry End Date";
      }
    }
    if (name === "Unit Quantity") {
      if (type === "start") {
        return "Min Unit Quantity";
      } else {
        return "Max Unit Quantity";
      }
    }
    if (name === "Subunit Quantity") {
      if (type === "start") {
        return "Min Subunit Quantity";
      } else {
        return "Max Subunit Quantity";
      }
    }
    if (name === "Taxes") {
      if (type === "start") {
        return "Min Tax %";
      } else {
        return "Max Tax %";
      }
    }
    if (name === "Landed Cost") {
      if (type === "start") {
        return "Min Landed Cost";
      } else {
        return "Max Landed Cost";
      }
    }
    if (name === "Unit Selling Price") {
      if (type === "start") {
        return "Min Unit Selling Price";
      } else {
        return "Max Unit Selling Price";
      }
    }
  };

  const handleBatchEdit = (batch) => {
    const reqBatch = batch;
    const reqObj = {
      ...batchValues,
      batchNumber: reqBatch?.batchNumber,
      manufacturingDate: reqBatch?.manufacturingDate,
      expiryDate: reqBatch?.expiryDate,
      location: batch?.location,
      quantity: reqBatch?.quantity,
      subunits: reqBatch?.subunits,
      unitSellingPrice: Number(reqBatch?.unitSellingPrice)?.toFixed(2),
      landedCost: Number(reqBatch?.landedCost)?.toFixed(2),
    };
    setBatchValues(reqObj);
    setEditValues({
      ...editValues,
      activeBatchIndex: batch?.i,
      isBatchEdit: true,
    });
  };

  const onCloseBatchEdit = () => {
    let reqBatchList = editValues?.batchList;
    if (
      batchValues?.batchNumber === "" &&
      batchValues?.manufacturingDate === null &&
      batchValues?.expiryDate === null &&
      batchValues?.location === null &&
      batchValues?.quantity === "" &&
      batchValues?.subunits === "" &&
      batchValues?.unitSellingPrice === "" &&
      batchValues?.landedCost === ""
    ) {
      reqBatchList = reqBatchList
        ?.filter((bat) => bat?.i !== editValues?.activeBatchIndex)
        ?.map((li, i) => ({ ...li, i }));
    }
    setEditValues({
      ...editValues,
      batchList: reqBatchList,
      isBatchEdit: false,
      activeBatchIndex: null,
    });
  };

  const handleAddNewBatch = () => {
    const batchList = [
      ...(editValues?.batchList ?? []),
      { ...initBatch, i: editValues?.batchList?.length ?? 0 },
    ];
    setBatchValues(initBatch);
    setEditValues({
      ...editValues,
      isBatchEdit: true,
      batchList,
      activeBatchIndex: editValues?.batchList?.length ?? 0,
    });
  };

  const handleBatchValidationCheck = () => {
    let hlp = {},
      err = {};
    batchRequiredFields?.forEach((fld) => {
      const reqValue =
        typeof batchValues?.[fld] === "object"
          ? batchValues?.[fld]?.value
          : batchValues?.[fld];
      if (typeof reqValue === "number" ? false : !reqValue) {
        err = {
          ...err,
          [fld]:
            fld === "unitSellingPrice"
              ? editValues?.billable
                ? true
                : false
              : true,
        };
        hlp = {
          ...hlp,
          [fld]:
            fld === "unitSellingPrice"
              ? editValues?.billable
                ? "This is required field"
                : ""
              : "This is required field",
        };
      }
    });
    setBatchHelps(hlp);
    setBatchErrs(err);
    return Object.values(err).some((item) => item);
  };

  const handleSaveBatch = () => {
    if (handleBatchValidationCheck()) return;
    const reqBatchList = editValues?.batchList?.map((bat) => {
      if (bat?.i === editValues?.activeBatchIndex) {
        const reqObj = {
          ...bat,
          i: bat?.i,
          batchNumber: batchValues?.batchNumber,
          manufacturingDate: batchValues?.manufacturingDate,
          expiryDate: batchValues?.expiryDate,
          location: batchValues?.location,
          quantity: batchValues?.quantity,
          subunits: batchValues?.subunits,
          unitSellingPrice: batchValues?.unitSellingPrice,
          landedCost: batchValues?.landedCost,
        };
        return reqObj;
      }
      return bat;
    });
    setBatchValues({});
    setBatchErrs({});
    setBatchHelps({});
    setEditValues({
      ...editValues,
      batchList: reqBatchList,
      activeBatchIndex: null,
      isBatchEdit: false,
    });
  };

  const onCloseBulkPriceMod = () => {
    setBulkPriceModVsble(false);
    setBulkPriceValues(initBulkPrices);
  };

  const onChangeBulkPriceValue = (e) => {
    const { name, value } = e?.target;
    const reqObj = { ...bulkPriceValues, [name]: value };
    if (name === "value") {
      reqObj.valueErr = value?.length > 0 ? "" : "This field is required";
    }
    setBulkPriceValues(reqObj);
  };

  const updateBulkPrice = () => {
    if (!bulkPriceValues?.value || bulkPriceValues?.value?.length === 0) {
      return setBulkPriceValues({
        ...bulkPriceValues,
        valueErr: "This field is required",
      });
    }
    const data = {
      priceType: bulkPriceValues?.valueType?.toLowerCase(),
      type: bulkPriceValues?.type?.toLowerCase(),
      priceValue: Math.abs(Number(bulkPriceValues?.value)),
    };
    dispatch(updateBulkPriceForStock(data)).then((res) => {
      if (res?.payload) {
        onCloseBulkPriceMod();
        onStockApiCall(1);
      }
    });
  };

  return (
    <>
      <Container maxWidth="xl">
        {penTblVsble ? (
          <StockPendingTable
            setPenTblVsble={setPenTblVsble}
            stckEntTblHdrs={stckEntTblHdrs}
          />
        ) : (
          <div className="com-mar back-white pv10">
            <div className="flex-row-ali-cen flex-center mt10">
              <div className="w15Per">
                <CustomTextField
                  placeholder="Product/Trade Name"
                  fullWidth
                  name="name"
                  backgroundColor={AppColors.lightBlue2}
                  value={searchValues?.name}
                  handleChange={onChangeSearch}
                  label="Product/Trade Name"
                />
              </div>
              <div className="w15Per ml20">
                <CustomTextField
                  placeholder="Barcode"
                  fullWidth
                  name="barCode"
                  backgroundColor={AppColors.lightBlue2}
                  value={searchValues?.barCode}
                  handleChange={onChangeSearch}
                  label="Barcode"
                />
              </div>
              <div className="w15Per ml20">
                <Select
                  list={productCategoryList}
                  value={searchValues?.category}
                  handleChange={onChangeSearch}
                  name="category"
                  label="Category"
                  multiSelectSearchCheck
                  backgroundColor={AppColors.lightBlue2}
                />
              </div>
              <div className="w15Per ml20">
                <Select
                  list={getLocationList()}
                  value={searchValues?.location}
                  handleChange={onChangeSearch}
                  name="location"
                  label="Location"
                  multiSelectSearchCheck
                  backgroundColor={AppColors.lightBlue2}
                />
              </div>
              <div
                className="flex-row-ali-cen ml20 filter cursor"
                onClick={() => onFilterChange("visible", true)}
              >
                <TuneIcon sx={{ color: AppColors.appPrimary }} />
                <Typography className="font-medium fs12 blue-color ml10">
                  {filterValues?.selectedList?.length > 0
                    ? `${filterValues?.selectedList?.length} `
                    : ""}
                  Filter
                </Typography>
              </div>
              <div className="ml20">
                <CustomButton text="Reset" onClick={onReset} smallBtn redBtn />
              </div>
              <div className="ml20 w10Per">
                <SplitButton list={options} handleClickItem={handleAction} />
              </div>
              {/* <div className="w30Per flex-row-ali-cen">
                <div className="ml20">
                  <SplitButton list={options} handleClickItem={handleAction} />
                </div>
                <div className="ml20">
                  <CustomButton text="Adjust" smallBtn onClick={handleAdjust} />
                </div>
                <div className="ml20 w35Per">
                  <CustomSelect
                    list={getDepartmentList()}
                    value={filterVal}
                    // label="Department *"
                    handleChange={(e) => handleFilter(e?.target?.value)}
                    select
                  />
                </div>
              </div> */}
            </div>
            <Typography className="font-medium fs12 gray28 ph20 mt10">
              Number of Stocks: {stocksByFilter?.totalRecords}
            </Typography>

            <Box className="pb-40 ph20">
              <TableContainer sx={{ maxHeight: 400 }}>
                <Table aria-label="collapsible table" stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        style={tblGrayBack}
                        className="txt-semi-bold fs12"
                      />
                      {tableHeaders?.map((th) => (
                        <TableCell
                          style={tblGrayBack}
                          className="txt-semi-bold fs12"
                        >
                          {nameExpan?.[th]}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  {stocksByFilter?.data?.length === 0 && (
                    <TableRow>
                      <TableCell
                        colSpan={12}
                        className="text-align-center h100"
                      >
                        <div className="no-rec">No records available</div>
                      </TableCell>
                    </TableRow>
                  )}
                  <TableBody>
                    {stockList?.length > 0 &&
                      stockList?.map((stock, i) => (
                        <TableDataRow
                          key={stock?.stockId + `${i}`}
                          data={stock}
                          ind={i}
                        />
                      ))}
                  </TableBody>

                  {Math.ceil(stocksByFilter?.totalRecords / rowsPerPage) > 1 ? (
                    <TableFooter>
                      <TableRow>
                        <TableCell colSpan={12}>
                          <div className="flex-end">
                            <Pagination
                              count={totalPage}
                              variant="outlined"
                              color="primary"
                              page={page}
                              onChange={handleChangePage}
                            />
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableFooter>
                  ) : null}
                </Table>
              </TableContainer>
            </Box>
          </div>
        )}
      </Container>

      <CustomModal
        open={bulkPriceModVsble}
        onClose={onCloseBulkPriceMod}
        header="Bulk Price Update"
        rightModal
        modalWidth={30}
      >
        <Grid container spacing={2} className="ph20">
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Select
              list={incDecList}
              value={bulkPriceValues?.type}
              handleChange={onChangeBulkPriceValue}
              name="type"
              label="Type"
              select
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Select
              list={discountTypes}
              value={bulkPriceValues?.valueType}
              handleChange={onChangeBulkPriceValue}
              name="valueType"
              label="Value Type"
              select
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <CustomTextField
              placeholder="Value"
              fullWidth
              name="value"
              label="Value"
              handleChange={onChangeBulkPriceValue}
              value={bulkPriceValues?.value}
              helperText={bulkPriceValues?.valueErr}
              error={!!bulkPriceValues?.valueErr}
              type="number"
            />
          </Grid>
          <div className="flex1-end mt20">
            <div>
              <CustomButton text="Update" smallBtn onClick={updateBulkPrice} />
            </div>
          </div>
        </Grid>
      </CustomModal>

      <CustomModal
        open={stcEntModVsble}
        onClose={handleCloseStcEnt}
        header="Stock Entry"
        headerCenter
        modalWidth={actStep === 1 ? 40 : 90}
        modal
      >
        <div className="scroll-90vh">
          <Grid container spacing={0} className="pb20">
            {actStep === 1 ? (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <div className="flex-row-ali-cen flex-center">
                  <Typography className="txt-semi-bold fs16 black">
                    Step {actStep}:
                  </Typography>
                  <Typography className="ml5 font-medium fs16 black">
                    Upload a clear picture of your supplier invoice
                  </Typography>
                </div>
              </Grid>
            ) : null}
            {actStep === 1 ? (
              <>
                {stcEntFiles?.length > 0 ? (
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    className="mt20"
                  >
                    <FilesWithCloseButton
                      files={stcEntFiles}
                      onClickFile={(i, fle) => handleImageRemove(i)}
                      center
                    />
                  </Grid>
                ) : null}
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  className="p20"
                >
                  <CustomUpload
                    onUploadFile={onEntFileUpload}
                    multipleNew
                    fileAccept="image/*,.pdf"
                    multiFiles
                  />
                </Grid>
                {stcEntFiles?.length > 0 ? null : (
                  <div className="flex1-center">
                    <div className="mb20">
                      <CustomButton
                        text="Manual Entry"
                        smallBtn
                        onClick={handleManualAddEntry}
                        tabOutlined
                      />
                    </div>
                  </div>
                )}
              </>
            ) : (
              <>
                <Grid container spacing={2} className="mv10">
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <div class="mb20">
                      <Select
                        list={getSupplierList()}
                        handleChange={(e, value) =>
                          handleChangeStckValue("supplierName", e?.value ?? e)
                        }
                        value={stckValue?.supplierName}
                        label="Supplier Name *"
                        error={stckErrs?.supplierName}
                        helperText={stckHelps?.supplierName}
                        // search
                        addNewSelect
                        plusBtn
                        addSearchDirectly
                      />
                      {/* <CustomTextField
                        name="supplierName"
                        required={true}
                        fullWidth
                        handleChange={(e) =>
                          handleChangeStckValue(
                            "supplierName",
                            e?.target?.value
                          )
                        }
                        value={stckValue?.supplierName}
                        label="Supplier Name"
                        error={stckErrs?.supplierName}
                        helperText={stckHelps?.supplierName}
                      // mandatoryField
                      // labelTop
                      /> */}
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <div class="mb20">
                      <CustomTextField
                        name="GSTIN"
                        fullWidth
                        handleChange={(e) =>
                          handleChangeStckValue("GSTIN", e?.target?.value)
                        }
                        value={stckValue?.GSTIN}
                        label="GSTIN"
                      />
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <div class="mb20">
                      <CustomTextField
                        name="email"
                        fullWidth
                        handleChange={(e) =>
                          handleChangeStckValue("email", e?.target?.value)
                        }
                        value={stckValue?.email}
                        label="Email"
                      />
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <div class="mb20">
                      <CustomTextField
                        name="phone"
                        fullWidth
                        handleChange={(e) =>
                          handleChangeStckValue("phone", e?.target?.value)
                        }
                        value={stckValue?.phone}
                        label="Phone"
                      />
                    </div>
                  </Grid>

                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <div class="mb20">
                      <CustomTextField
                        name="address"
                        fullWidth
                        handleChange={(e) =>
                          handleChangeStckValue("address", e?.target?.value)
                        }
                        value={stckValue?.address}
                        multiline
                        rows={3}
                        label="Address"
                      />
                    </div>
                  </Grid>

                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <div class="mb20">
                      <CustomTextField
                        name="invoiceNumber"
                        fullWidth
                        handleChange={(e) =>
                          handleChangeStckValue(
                            "invoiceNumber",
                            e?.target?.value,
                          )
                        }
                        value={stckValue?.invoiceNumber}
                        label="Invoice Number"
                        error={stckErrs?.invoiceNumber}
                        helperText={stckHelps?.invoiceNumber}
                        required={true}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <div class="mb20">
                      <CustomTextField
                        name="date"
                        fullWidth
                        handleChange={(e) =>
                          handleChangeStckValue("billDate", e?.target?.value)
                        }
                        value={stckValue?.billDate}
                        mobileDateWithBatch
                        label="Date *"
                        required={true}
                        error={stckErrs?.billDate}
                        helperText={stckHelps?.billDate}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <div class="mb20">
                      <Select
                        list={purchaseTypes}
                        handleChange={(e, value) =>
                          handleChangeStckValue("purchaseType", value)
                        }
                        value={stckValue?.purchaseType}
                        label="Purchase Type"
                        search
                      />
                    </div>
                  </Grid>
                </Grid>

                <TableContainer sx={{ maxHeight: 300 }} className="mb20">
                  <Table
                    sx={{ minWidth: 200 }}
                    aria-labelledby="tableTitle"
                    stickyHeader
                  >
                    <TableHead>
                      <TableRow>
                        {(stckValue?.purchaseType?.value === "Interstate"
                          ? stckEntIgstTblHdrs
                          : stckEntTblHdrs
                        )?.map((hdr, i) => (
                          <TableCell
                            style={tblGrayBack}
                            className={`table-header-text`}
                          >
                            <div
                              style={{
                                width:
                                  hdr === "sno"
                                    ? 30
                                    : hdr === "hsnSacCode"
                                      ? 120
                                      : hdr === "name"
                                        ? 200
                                        : hdr === "quantity" ||
                                            hdr === "samples" ||
                                            hdr === "cgst" ||
                                            hdr === "sgst" ||
                                            hdr === "gst" ||
                                            i ===
                                              (stckValue?.purchaseType
                                                ?.value === "Interstate"
                                                ? stckEntIgstTblHdrs
                                                : stckEntTblHdrs
                                              )?.length -
                                                1
                                          ? 70
                                          : hdr === "purchaseUom"
                                            ? 100
                                            : hdr === "discounts"
                                              ? 80
                                              : 130,
                              }}
                            >
                              {stckNmeExpan?.[hdr]}
                            </div>
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {stckValue?.list?.map((li, ind) => {
                        return (
                          <TableRow>
                            {(stckValue?.purchaseType?.value === "Interstate"
                              ? stckEntIgstTblHdrs
                              : stckEntTblHdrs
                            )?.map((hdr, i) => (
                              <TableCell
                                key={ind + `${i}` + "tr"}
                                component="th"
                                sx={{ verticalAlign: "top" }}
                              >
                                <div
                                  style={{
                                    width:
                                      hdr === "sno"
                                        ? 30
                                        : hdr === "hsnSacCode"
                                          ? 120
                                          : hdr === "name"
                                            ? 200
                                            : hdr === "quantity" ||
                                                hdr === "samples" ||
                                                hdr === "cgst" ||
                                                hdr === "sgst" ||
                                                hdr === "gst" ||
                                                i ===
                                                  (stckValue?.purchaseType
                                                    ?.value === "Interstate"
                                                    ? stckEntIgstTblHdrs
                                                    : stckEntTblHdrs
                                                  )?.length -
                                                    1
                                              ? 70
                                              : hdr === "purchaseUom"
                                                ? 100
                                                : hdr === "discounts"
                                                  ? 80
                                                  : 130,
                                  }}
                                >
                                  {i ===
                                  (stckValue?.purchaseType?.value ===
                                  "Interstate"
                                    ? stckEntIgstTblHdrs
                                    : stckEntTblHdrs
                                  )?.length -
                                    1 ? (
                                    <img
                                      src={require("../../../assets/images/png/delete.png")}
                                      className="imghw30 cursor mt5"
                                      onClick={() => handleDeleteRow(ind)}
                                    />
                                  ) : li?.apiCalled ? (
                                    hdr === "name" ? (
                                      <Custom3dotString
                                        str={li?.[hdr]}
                                        className="font-regular fs14"
                                        length={13}
                                      />
                                    ) : (
                                      (li?.product?.[hdr] ?? li?.[hdr])
                                    )
                                  ) : hdr === "sno" ? (
                                    ind + 1
                                  ) : (
                                    <CustomTextField
                                      name={hdr}
                                      fullWidth
                                      handleChange={(e) =>
                                        handleChangeTableValue(
                                          hdr,
                                          e?.target?.value,
                                          ind,
                                        )
                                      }
                                      error={!!li?.errors?.[hdr]}
                                      helperText={li?.errors?.[hdr]}
                                      value={
                                        hdr === "taxes"
                                          ? Number(li?.[hdr])?.toFixed(2)
                                          : li?.[hdr]
                                      }
                                      disabled={
                                        hdr === "taxes" ||
                                        (stckValue?.purchaseType?.value ===
                                        "Exempt"
                                          ? hdr === "cgst" || hdr === "sgst"
                                          : false)
                                      }
                                      type={
                                        hdr === "hsnSacCode" ||
                                        hdr === "name" ||
                                        hdr === "purchaseUom"
                                          ? "string"
                                          : "number"
                                      }
                                    />
                                  )}
                                </div>
                              </TableCell>
                            ))}
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
                <div>
                  <CustomButton text="Add" smallBtn onClick={handleAdd} />
                </div>
                <div className="flex1-end pr50">
                  <div className="w25Per">
                    <div className="flex-row-ali-cen">
                      <div className="w60Per">
                        <div className="font-medium fs14 black">
                          Total Taxable Value
                        </div>
                      </div>
                      <div className="flex1-end pr10">
                        {Number(
                          getTotalValues({
                            list: stckValue?.list,
                            additionalCharges: stckValue?.additionalCharges,
                          })?.taxableValues,
                        )?.toFixed(2)}
                      </div>
                    </div>
                    {stckValue?.purchaseType?.value === "Interstate" ? (
                      <div className="flex-row-ali-cen mt10">
                        <div className="w60Per">
                          <div className="font-medium fs14 black">
                            Taxes (IGST)
                          </div>
                        </div>
                        <div className="flex1-end pr10">
                          {Number(
                            getTotalValues({
                              list: stckValue?.list,
                              additionalCharges: stckValue?.additionalCharges,
                            })?.taxes,
                          )?.toFixed(2)}
                        </div>
                      </div>
                    ) : (
                      <div>
                        <div className="flex-row-ali-cen mt10">
                          <div className="w60Per">
                            <div className="font-medium fs14 black">
                              Taxes (CGST)
                            </div>
                          </div>
                          <div className="flex1-end pr10">
                            {Number(
                              Number(
                                getTotalValues({
                                  list: stckValue?.list,
                                  additionalCharges:
                                    stckValue?.additionalCharges,
                                })?.taxes,
                              ) / 2,
                            )?.toFixed(2)}
                          </div>
                        </div>
                        <div className="flex-row-ali-cen mt10">
                          <div className="w60Per">
                            <div className="font-medium fs14 black">
                              Taxes (SGST)
                            </div>
                          </div>
                          <div className="flex1-end pr10">
                            {Number(
                              Number(
                                getTotalValues({
                                  list: stckValue?.list,
                                  additionalCharges:
                                    stckValue?.additionalCharges,
                                })?.taxes,
                              ) / 2,
                            )?.toFixed(2)}
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="flex-row-ali-cen mt10">
                      <div className="w60Per">
                        <div className="font-medium fs14 black">
                          Additional Charges
                        </div>
                      </div>
                      <div className="flex1-end">
                        <CustomTextField
                          fullWidth
                          handleChange={(e) =>
                            handleChangeAdditionalCharge(
                              "additionalCharges",
                              e?.target?.value,
                            )
                          }
                          value={stckValue?.additionalCharges}
                          type="number"
                          textRightAlign
                        />
                      </div>
                    </div>
                    <div className="flex-row-ali-cen mt10">
                      <div className="flex-start">
                        <div className="font-medium fs14 black">
                          Grand Total
                        </div>
                      </div>
                      <div className="flex1-end pr10">
                        <div className="font-bold fs14 black">
                          {Number(
                            getTotalValues({
                              list: stckValue?.list,
                              additionalCharges: stckValue?.additionalCharges,
                            })?.grandTotal,
                          )?.toFixed(2)}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              {actStep === 1 ? (
                stockEntrErr ? (
                  <div className="flex-center mb10">
                    <FormHelperText error>
                      Unable to process the request. Kindly upload a clear
                      picture and try again.
                    </FormHelperText>
                  </div>
                ) : null
              ) : submitErr ? (
                <div className="flex-center mb10">
                  <FormHelperText error>
                    Please upload images against each product to complete the
                    process or skip to continue later.
                  </FormHelperText>
                </div>
              ) : null}

              {isListNotValid ? (
                <div className="flex-center mb10">
                  <FormHelperText error>
                    Please add at least 1 record
                  </FormHelperText>
                </div>
              ) : null}

              <div className="flex-center">
                <div className="flex-row">
                  <CustomButton
                    text="Submit"
                    smallBtn
                    onClick={() => {
                      actStep === 1 ? onStcEntUpload() : onStcApiCall();
                    }}
                  />
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </CustomModal>

      <CustomModal
        open={adjustModVsble}
        onClose={handleCloseAdjMod}
        header="Stock Adjustment"
        modalWidth={30}
        rightModal
      >
        <div className="scroll-90vh">
          <Grid container spacing={2} className="ph20">
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="txt-semi-bold fs14 light-grey">
                Type <span className="red-color">*</span>
              </div>
              <Select
                list={StockAdjustList}
                handleChange={(e, value) =>
                  handleChangeAdjustValue("type", value)
                }
                value={adjustValues?.type}
                helperText={adjustHelpers?.type}
                error={adjustErrors?.type}
                search
              />
            </Grid>
            {adjustValues?.type?.value === "Return on Purchase" ? (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <div className="txt-semi-bold fs14 light-grey">
                  Supplier <span className="red-color">*</span>
                </div>
                <Select
                  list={getSupplierList()}
                  handleChange={(e, value) =>
                    handleChangeAdjustValue("supplier", value)
                  }
                  value={adjustValues?.supplier}
                  helperText={adjustHelpers?.supplier}
                  error={adjustErrors?.supplier}
                  search
                />
              </Grid>
            ) : null}
            {adjustValues?.type?.value === "Return on Sales" ? (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <div className="txt-semi-bold fs14 light-grey">
                  Customer <span className="red-color">*</span>
                </div>
                <Select
                  list={userList}
                  handleChange={(e, value) =>
                    handleChangeAdjustValue("customer", value)
                  }
                  value={adjustValues?.customer}
                  helperText={adjustHelpers?.customer}
                  error={adjustErrors?.customer}
                  search
                />
              </Grid>
            ) : null}
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="txt-semi-bold fs14 light-grey">
                Product <span className="red-color">*</span>
              </div>
              <Select
                list={productList}
                handleChange={(e, value) =>
                  handleChangeAdjustValue("product", value)
                }
                value={adjustValues?.product}
                helperText={adjustHelpers?.product}
                error={adjustErrors?.product}
                search
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <div className="txt-semi-bold fs14 light-grey">
                Batch Number <span className="red-color">*</span>
              </div>
              <Select
                list={getBatchNumbersByProduct(adjustValues?.product?.value)}
                handleChange={(e, value) =>
                  handleChangeAdjustValue("batchNumber", value)
                }
                value={adjustValues?.batchNumber}
                helperText={adjustHelpers?.batchNumber}
                error={adjustErrors?.batchNumber}
                search
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <div className="txt-semi-bold fs14 light-grey">
                Quantity <span className="red-color">*</span>
                {adjustValues?.type?.value === "Other Adjustments" ? (
                  <Tooltip
                    title="Enter a positive value to increase 
                         the quantity or enter a negative 
                         value to decrease the quantity"
                    className="ml5"
                  >
                    <InfoOutlinedIcon
                      sx={{ width: 15, height: 15, color: AppColors.red }}
                    />
                  </Tooltip>
                ) : null}
              </div>

              <CustomTextField
                handleChange={(e) =>
                  handleChangeAdjustValue("quantity", e?.target?.value)
                }
                value={adjustValues?.quantity}
                helperText={adjustHelpers?.quantity}
                error={adjustErrors?.quantity}
                fullWidth
                type="number"
              />
            </Grid>
            {adjustValues?.type?.value !== "Other Adjustments" ? (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <div className="txt-semi-bold fs14 light-grey">
                  Invoice Number
                </div>
                <CustomTextField
                  handleChange={(e) =>
                    handleChangeAdjustValue("invoiceNumber", e?.target?.value)
                  }
                  value={adjustValues?.invoiceNumber}
                  helperText={adjustHelpers?.invoiceNumber}
                  error={adjustErrors?.invoiceNumber}
                  fullWidth
                />
              </Grid>
            ) : null}
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="txt-semi-bold fs14 light-grey">
                Remarks
                {adjustValues?.type?.value === "Other Adjustments" ? (
                  <span className="red-color"> *</span>
                ) : null}
              </div>
              <CustomTextField
                handleChange={(e) =>
                  handleChangeAdjustValue("remarks", e?.target?.value)
                }
                value={adjustValues?.remarks}
                helperText={adjustHelpers?.remarks}
                error={adjustErrors?.remarks}
                fullWidth
                rows={3}
                multiline
                required={adjustValues?.type?.value === "Other Adjustments"}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex1-end mt10">
                <div>
                  <CustomButton
                    text="Submit"
                    smallBtn
                    onClick={handleStockAdjust}
                  />
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </CustomModal>

      <CustomModal
        open={editModVsble}
        onClose={onCloseEditMod}
        header={isManualEntry ? "Create Stock" : "Edit"}
        headerCenter
        modalWidth={100}
        modal
      >
        <div className="ph20 scroll-80vh">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex-row">
                <Typography className="font-bold fs16 blue-color">
                  Product Details
                </Typography>
                {selectedItem ? (
                  <div className="flex1-end">
                    <div>
                      <Typography className="gray-color fs12 font-medium">
                        Created Date:{" "}
                        {moment(
                          new Date(selectedItem?.createdDate ?? new Date()),
                        ).format("DD MMM YYYY, HH:mm")}
                      </Typography>
                      <Typography className="gray-color fs12 font-medium">
                        Updated Date:{" "}
                        {moment(
                          new Date(
                            selectedItem?.updatedDate ??
                              selectedItem?.createdDate ??
                              new Date(),
                          ),
                        ).format("DD MMM YYYY, HH:mm")}
                      </Typography>
                    </div>
                  </div>
                ) : null}
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <CustomCheckbox
                label="Active"
                checked={editValues?.active}
                onChange={() => handleChange("active", !editValues?.active)}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex-row-ali-cen">
                <div>
                  <CustomCheckbox
                    label="Billable"
                    checked={editValues?.billable}
                    onChange={() =>
                      handleChange("billable", !editValues?.billable)
                    }
                  />
                </div>
                <div className="ml20">
                  <CustomCheckbox
                    label="Auto-consumed"
                    checked={editValues?.autoConsumed}
                    onChange={() =>
                      handleChange("autoConsumed", !editValues?.autoConsumed)
                    }
                  />
                </div>
              </div>
            </Grid>
            {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <CustomCheckbox
                label="Disabled"
                checked={editValues?.active}
                onChange={() => handleChange("active", !editValues?.active)}
              />
            </Grid> */}
            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div className="mb20">
                <CustomTextField
                  name="skuId"
                  label="SKU ID "
                  // required={true}
                  fullWidth
                  value={editValues?.skuId}
                  // error={editErrs?.skuId}
                  // helperText={editHelps?.skuId}
                  handleChange={(e) => handleChange("skuId", e?.target?.value)}
                />
              </div>
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div className="mb20">
                <Select
                  list={productCategoryList}
                  value={editValues?.category}
                  handleChange={(e, value) => handleChange("category", value)}
                  name="category"
                  search
                  error={editErrs?.category}
                  helperText={editHelps?.category}
                  label="Category * "
                />
              </div>
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div className="mb20">
                <CustomTextField
                  name="subCategory"
                  label="Subcategory "
                  required={true}
                  fullWidth
                  value={editValues?.subCategory}
                  error={editErrs?.subCategory}
                  helperText={editHelps?.subCategory}
                  handleChange={(e) =>
                    handleChange("subCategory", e?.target?.value)
                  }
                />
              </div>
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div className="mb20">
                <CustomTextField
                  name="hsnSacCode"
                  fullWidth
                  value={editValues?.hsnSacCode}
                  error={editErrs?.hsnSacCode}
                  helperText={editHelps?.hsnSacCode}
                  label="HSN Code"
                  handleChange={(e) =>
                    handleChange("hsnSacCode", e?.target?.value)
                  }
                />
              </div>
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div class="mb20">
                <CustomTextField
                  name="name"
                  fullWidth
                  label="Name"
                  required={true}
                  value={editValues?.name}
                  error={editErrs?.name}
                  helperText={editHelps?.name}
                  handleChange={(e) => handleChange("name", e?.target?.value)}
                />
              </div>
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div class="mb20">
                <CustomTextField
                  name="tradeName"
                  fullWidth
                  label="Trade Name "
                  required={true}
                  value={editValues?.tradeName}
                  error={editErrs?.tradeName}
                  helperText={editHelps?.tradeName}
                  handleChange={(e) =>
                    handleChange("tradeName", e?.target?.value)
                  }
                />
              </div>
            </Grid>

            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div class="mb20">
                <CustomTextField
                  name="ingredient"
                  label="Major Active Ingredients"
                  fullWidth
                  value={editValues?.ingredient}
                  error={editErrs?.ingredient}
                  helperText={editHelps?.ingredient}
                  handleChange={(e) =>
                    handleChange("ingredient", e?.target?.value)
                  }
                />
              </div>
            </Grid>

            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div class="mb20">
                <CustomTextField
                  name="nature"
                  label="Nature "
                  fullWidth
                  value={editValues?.nature}
                  error={editErrs?.nature}
                  helperText={editHelps?.nature}
                  handleChange={(e) => handleChange("nature", e?.target?.value)}
                />
              </div>
            </Grid>

            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div class="mb20">
                <CustomTextField
                  name="code"
                  label="Barcode Number"
                  fullWidth
                  value={editValues?.code}
                  error={editErrs?.code}
                  helperText={editHelps?.code}
                  handleChange={(e) => handleChange("code", e?.target?.value)}
                />
              </div>
            </Grid>

            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div class="mb20">
                <CustomTextField
                  name="brand"
                  label="Brand"
                  fullWidth
                  value={editValues?.brand}
                  error={editErrs?.brand}
                  helperText={editHelps?.brand}
                  handleChange={(e) => handleChange("brand", e?.target?.value)}
                />
              </div>
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div class="mb20">
                <CustomTextField
                  name="reorderLevel"
                  label="Reorder Level"
                  fullWidth
                  value={editValues?.reorderLevel}
                  error={editErrs?.reorderLevel}
                  helperText={editHelps?.reorderLevel}
                  handleChange={(e) =>
                    handleChange("reorderLevel", e?.target?.value)
                  }
                  type="number"
                />
              </div>
            </Grid>
            {drugScheduleShowCategoryList?.includes(
              editValues?.category?.value?.toLowerCase(),
            ) ? (
              <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                <div className="mb20">
                  <Select
                    list={drugScheduleList}
                    value={editValues?.drugSchedule}
                    handleChange={(e, value) =>
                      handleChange("drugSchedule", value)
                    }
                    name="drugSchedule"
                    search
                    error={editErrs?.drugSchedule}
                    helperText={editHelps?.drugSchedule}
                    label="Drug Schedule"
                  />
                </div>
              </Grid>
            ) : null}

            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div class="mb20">
                <CustomTextField
                  name="purchaseUom"
                  label="Purchase UOM"
                  fullWidth
                  value={editValues?.purchaseUom}
                  error={editErrs?.purchaseUom}
                  helperText={editHelps?.purchaseUom}
                  handleChange={(e) =>
                    handleChange("purchaseUom", e?.target?.value)
                  }
                />
              </div>
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div class="mb20">
                <CustomTextField
                  name="salesUom"
                  label="Sales UOM"
                  fullWidth
                  value={editValues?.salesUom}
                  error={editErrs?.salesUom}
                  helperText={editHelps?.salesUom}
                  handleChange={(e) =>
                    handleChange("salesUom", e?.target?.value)
                  }
                />
              </div>
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div class="mb20">
                <CustomTextField
                  name="conversionFactor"
                  fullWidth
                  label="UOM Conversion Factor"
                  value={editValues?.conversionFactor}
                  error={editErrs?.conversionFactor}
                  helperText={editHelps?.conversionFactor}
                  handleChange={(e) =>
                    handleChange("conversionFactor", e?.target?.value)
                  }
                />
              </div>
            </Grid>

            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div className="flex-row">
                <div className="w60Per pr10">
                  <CustomTextField
                    name="packageUom"
                    label="Administered UOM"
                    fullWidth
                    value={editValues?.packageUom}
                    error={editErrs?.packageUom}
                    helperText={editHelps?.packageUom}
                    handleChange={(e) =>
                      handleChange("packageUom", e?.target?.value)
                    }
                    type="number"
                  />
                </div>
                <div className="w40Per">
                  <Select
                    list={administeredUOMList}
                    value={editValues?.adminUom}
                    handleChange={(e, value) => handleChange("adminUom", value)}
                    name="adminUom"
                    search
                    error={editErrs?.adminUom}
                    helperText={editHelps?.adminUom}
                  />
                </div>
              </div>
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div className="flex-row">
                <div className="w60Per pr10">
                  <CustomTextField
                    name="dosage"
                    label="Dosage"
                    fullWidth
                    value={editValues?.dosage}
                    error={editErrs?.dosage}
                    helperText={editHelps?.dosage}
                    handleChange={(e) =>
                      handleChange("dosage", e?.target?.value)
                    }
                    type="number"
                    endIcon
                    inputIcon={
                      <Custom3dotString
                        str={editValues?.adminUom?.name ?? ""}
                        length={9}
                        className="fs12 font-medium"
                      />
                    }
                  />
                </div>
                <div className="w40Per">
                  <Select
                    list={dosageTypes}
                    value={editValues?.dosageType}
                    handleChange={(e, value) =>
                      handleChange("dosageType", value)
                    }
                    name="dosageType"
                    search
                    error={editErrs?.dosageType}
                    helperText={editHelps?.dosageType}
                  />
                </div>
              </div>
            </Grid>

            {editValues?.billable && (
              <>
                <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                  <div class="mb20">
                    <CustomTextField
                      name="cgst"
                      fullWidth
                      label="CGST (%)"
                      required={true}
                      value={editValues?.cgst}
                      error={editErrs?.cgst}
                      helperText={editHelps?.cgst}
                      handleChange={(e) =>
                        handleChange("cgst", e?.target?.value)
                      }
                      type="number"
                    />
                  </div>
                </Grid>
                <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                  <div class="mb20">
                    <CustomTextField
                      name="sgst"
                      fullWidth
                      label="SGST (%)"
                      required={true}
                      value={editValues?.sgst}
                      error={editErrs?.sgst}
                      helperText={editHelps?.sgst}
                      handleChange={(e) =>
                        handleChange("sgst", e?.target?.value)
                      }
                      type="number"
                    />
                  </div>
                </Grid>
                {/* <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                  <div class="mb20">
                    <CustomTextField
                      name="itemTotal"
                      fullWidth
                      label=" Item Total (Buying) "
                      required={true}
                      value={editValues?.itemTotal}
                      error={editErrs?.itemTotal}
                      helperText={editHelps?.itemTotal}
                      handleChange={(e) =>
                        handleChange("itemTotal", e?.target?.value)
                      }
                      disabled={!isManualEntry}
                    />
                  </div>
                </Grid> */}
              </>
            )}

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div class="mb20">
                <CustomTextField
                  name="description"
                  label="Brief Description of the Product"
                  fullWidth
                  value={editValues?.description}
                  error={editErrs?.description}
                  helperText={editHelps?.description}
                  handleChange={(e) =>
                    handleChange("description", e?.target?.value)
                  }
                  multiline
                />
              </div>
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex-row-ali-cen">
                <Typography className="font-bold fs16 blue-color">
                  Batch Details
                </Typography>
                {editValues?.isBatchEdit ? (
                  <>
                    <div className="ml10">
                      <CustomButton
                        text="Save"
                        onClick={handleSaveBatch}
                        smallBtn
                      />
                    </div>
                    <div className="ml10">
                      <CustomButton
                        text="Discard"
                        onClick={onCloseBatchEdit}
                        redBtn
                        smallBtn
                      />
                    </div>
                  </>
                ) : (
                  <div
                    className="flex-row-ali-cen cursor ml10"
                    onClick={handleAddNewBatch}
                  >
                    <div className="flex-center plus-icon">
                      <AddIcon sx={addIcon} />
                    </div>
                    <Typography className="blue-color fs16 ml5 font-bold">
                      Add
                    </Typography>
                  </div>
                )}
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex-row scrollx scroll-hor">
                {!editValues?.isBatchEdit &&
                  editValues?.batchList?.length > 0 &&
                  (editValues?.batchList ?? [])
                    ?.filter((sb) => {
                      const userMatch = sb?.createdBy === profile?.id;
                      const matchedDataSharing =
                        branchesDataSharing?.find(
                          (li) => li?.createdBy === sb?.createdBy,
                        ) ?? {};
                      const accessmatch = matchedDataSharing
                        ? (matchedDataSharing?.inventryData ?? false)
                        : false;
                      return sb?.createdBy ? userMatch || accessmatch : true;
                    })
                    ?.map((sb, i) => (
                      <div
                        className={`blue-box-examD ${i !== 0 ? "ml20" : ""}`}
                        style={{ width: 400, flexShrink: 0 }}
                        key={sb?.batchId}
                      >
                        <div className="flex-row-ali-cen">
                          <Typography className="font-bold fs14 blue-color">
                            Batch Number :{" "}
                          </Typography>
                          <Typography className="txt-semi-bold fs14 black20 ml5">
                            {sb?.batchNumber ?? ""}
                          </Typography>
                          <div className="flex1-end">
                            <div
                              className="cursor"
                              onClick={() => handleBatchEdit(sb)}
                            >
                              <div className="flex-center">
                                <EditIcon sx={plusBtn} />
                              </div>
                              <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                                Edit
                              </Typography>
                            </div>
                          </div>
                        </div>
                        <div className="flex-row">
                          <div className="w50Per">
                            <div className="flex-row-ali-cen">
                              <div className="gray-dot" />
                              <Typography className="font-medium fs12 blue-color ml5">
                                Mfg Date :{" "}
                              </Typography>
                              <Typography className="font-medium fs12 black20 ml5">
                                {sb?.manufacturingDate
                                  ? moment(
                                      new Date(sb?.manufacturingDate),
                                    ).format("YYYY-MM-DD")
                                  : null}
                              </Typography>
                            </div>
                            <div className="flex-row-ali-cen">
                              <div className="gray-dot" />
                              <Typography className="font-medium fs12 blue-color ml5">
                                Unit Qty :{" "}
                              </Typography>
                              <Typography className="font-medium fs12 black20 ml5">
                                {sb?.quantity}
                              </Typography>
                            </div>
                            <div className="flex-row-ali-cen">
                              <div className="gray-dot" />
                              <Typography className="font-medium fs12 blue-color ml5">
                                Selling Price :{" "}
                              </Typography>
                              <Typography className="font-medium fs12 black20 ml5">
                                {Number(
                                  getExactNumber(sb?.unitSellingPrice),
                                )?.toFixed(2)}
                              </Typography>
                            </div>
                          </div>
                          <div className="w50Per">
                            <div className="flex-row-ali-cen">
                              <div className="gray-dot" />
                              <Typography className="font-medium fs12 blue-color ml5">
                                Expiry Date :{" "}
                              </Typography>
                              <Typography className="font-medium fs12 black20 ml5">
                                {sb?.expiryDate
                                  ? moment(new Date(sb?.expiryDate)).format(
                                      "YYYY-MM-DD",
                                    )
                                  : null}
                              </Typography>
                            </div>
                            <div className="flex-row-ali-cen">
                              <div className="gray-dot" />
                              <Typography className="font-medium fs12 blue-color ml5">
                                Subunit Qty :{" "}
                              </Typography>
                              <Typography className="font-medium fs12 black20 ml5">
                                {sb?.subunits ?? ""}
                              </Typography>
                            </div>
                            <div className="flex-row-ali-cen">
                              <div className="gray-dot" />
                              <Typography className="font-medium fs12 blue-color ml5">
                                Landed Cost :{" "}
                              </Typography>
                              <Typography className="font-medium fs12 black20 ml5">
                                {Number(
                                  getExactNumber(sb?.landedCost),
                                )?.toFixed(2)}
                              </Typography>
                            </div>
                            {/* <div className="flex-row-ali-cen">
                          <div className="gray-dot" />
                          <Typography className="font-medium fs12 blue-color ml5">
                            Dosage :{" "}
                          </Typography>
                          <Typography className="font-medium fs12 black20 ml5">
                            {sb?.dosage ?? ""}
                          </Typography>
                        </div> */}
                          </div>
                        </div>
                        <div className="flex-row-ali-cen">
                          <div className="gray-dot" />
                          <Typography className="font-medium fs12 blue-color ml5">
                            Location :{" "}
                          </Typography>
                          <Typography className="font-medium fs12 black20 ml5">
                            {typeof sb?.location === "object" &&
                            sb?.location !== null
                              ? (sb?.location?.name ??
                                sb?.location?.value ??
                                "")
                              : (sb?.location ?? "")}
                          </Typography>
                        </div>
                      </div>
                    ))}
              </div>
            </Grid>
            {editValues?.isBatchEdit && (
              <>
                <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                  {/* {isManualEntry ? ( */}
                  <div class="mb20">
                    <CustomTextField
                      fullWidth
                      label="Batch Number"
                      value={batchValues?.batchNumber}
                      handleChange={(e) =>
                        handleBatchChange("batchNumber", e?.target?.value)
                      }
                    />
                  </div>
                  {/* ) : (
                <div class="mb20">
                  <Select
                    label="Batch Number"
                    list={getBatchList(selectedItem?.stockId)}
                    value={editValues?.batchNumber}
                    handleChange={(e) => {
                      handleChange("batchNumber", e?.value ?? e, {
                        batchId: e?.apiValue ?? null,
                      });
                    }}
                    addNewSelect
                    plusBtn
                  />
                </div>
              )} */}
                </Grid>

                <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                  <div class="mb20">
                    <CustomTextField
                      label="Mfg Date"
                      fullWidth
                      value={batchValues?.manufacturingDate}
                      error={batchErrs?.manufacturingDate}
                      helperText={batchHelps?.manufacturingDate}
                      handleChange={(e) =>
                        handleBatchChange("manufacturingDate", e?.target?.value)
                      }
                      mobileDateWithBatch
                    />
                  </div>
                </Grid>

                <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                  <div class="mb20">
                    <CustomTextField
                      fullWidth
                      label="Expiry Date"
                      value={batchValues?.expiryDate}
                      error={batchErrs?.expiryDate}
                      helperText={batchHelps?.expiryDate}
                      handleChange={(e) =>
                        handleBatchChange("expiryDate", e?.target?.value)
                      }
                      mobileDateWithBatch
                    />
                  </div>
                </Grid>

                <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                  <div class="mb20">
                    <Select
                      list={getLocationList()}
                      value={batchValues?.location}
                      handleChange={(e, value) =>
                        handleBatchChange("location", value)
                      }
                      name="location"
                      label="Location *"
                      search
                      error={batchErrs?.location}
                      helperText={batchHelps?.location}
                    />
                  </div>
                </Grid>
                <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                  <div class="mb20">
                    <CustomTextField
                      name="quantity"
                      label="Unit Qty"
                      required={true}
                      fullWidth
                      value={batchValues?.quantity}
                      error={batchErrs?.quantity}
                      helperText={batchHelps?.quantity}
                      handleChange={(e) =>
                        handleBatchChange("quantity", e?.target?.value)
                      }
                      type="number"
                    />
                  </div>
                </Grid>
                <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                  <div class="mb20">
                    <CustomTextField
                      name="subunits"
                      fullWidth
                      label="Subunit Qty"
                      required={true}
                      value={batchValues?.subunits}
                      error={batchErrs.subunits}
                      helperText={batchHelps.subunits}
                      handleChange={(e) =>
                        handleBatchChange("subunits", e?.target?.value)
                      }
                      disabled={!isManualEntry}
                      type="number"
                    />
                  </div>
                </Grid>
                <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                  <div class="mb20">
                    <CustomTextField
                      name="unitSellingPrice"
                      label="Selling Price"
                      required={true}
                      fullWidth
                      value={batchValues?.unitSellingPrice}
                      error={batchErrs?.unitSellingPrice}
                      helperText={batchHelps?.unitSellingPrice}
                      handleChange={(e) =>
                        handleBatchChange("unitSellingPrice", e?.target?.value)
                      }
                      type="number"
                    />
                    <div className="fs12 gray-color txt-regular mt5">
                      Price is for subunits
                    </div>
                  </div>
                </Grid>
                <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                  <div class="mb20">
                    <CustomTextField
                      name="landedCost"
                      fullWidth
                      label="Landed Cost (Buying)"
                      value={batchValues?.landedCost}
                      error={batchErrs?.landedCost}
                      helperText={batchHelps?.landedCost}
                      handleChange={(e) =>
                        handleBatchChange("landedCost", e?.target?.value)
                      }
                      disabled={!isManualEntry}
                    />
                  </div>
                </Grid>

                {/* {editValues?.billable ? (
                  <>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <Typography className="font-bold fs16 blue-color">
                        Price & Taxes
                      </Typography>
                    </Grid>

                    <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                      <div class="mb20">
                        <CustomTextField
                          name="cgst"
                          fullWidth
                          label="CGST (%)"
                          required={true}
                          value={editValues?.cgst}
                          error={editErrs?.cgst}
                          helperText={editHelps?.cgst}
                          handleChange={(e) =>
                            handleChange("cgst", e?.target?.value)
                          }
                          type="number"
                        />
                      </div>
                    </Grid>
                    <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                      <div class="mb20">
                        <CustomTextField
                          name="sgst"
                          fullWidth
                          label="SGST (%)"
                          required={true}
                          value={editValues?.sgst}
                          error={editErrs?.sgst}
                          helperText={editHelps?.sgst}
                          handleChange={(e) =>
                            handleChange("sgst", e?.target?.value)
                          }
                          type="number"
                        />
                      </div>
                    </Grid>
                    <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                      <div class="mb20">
                        <CustomTextField
                          name="itemTotal"
                          fullWidth
                          label=" Item Total (Buying) "
                          required={true}
                          value={editValues?.itemTotal}
                          error={editErrs?.itemTotal}
                          helperText={editHelps?.itemTotal}
                          handleChange={(e) =>
                            handleChange("itemTotal", e?.target?.value)
                          }
                          disabled={!isManualEntry}
                        />
                      </div>
                    </Grid>
                  </>
                ) : null} */}
              </>
            )}
          </Grid>

          <div className="mt30">
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <div className="flex1-center">
                <div className="flex-row-ali-cen">
                  {/* <div className="mr10">
                    <CustomButton
                      text="Cancel"
                      textBtn
                      onClick={onCloseEditMod}
                      color={AppColors.red}
                    />
                  </div> */}
                  <div className="ml10">
                    <CustomButton
                      text="Submit"
                      onClick={handleSubmit}
                      smallBtn
                    />
                  </div>
                </div>
              </div>
            </Grid>
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={filterValues?.visible}
        onClose={onCloseFilter}
        header="Filter"
        rightModal
        modalWidth={30}
      >
        <div className="scroll-80vh ph20">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography className="gray38 fs12 txt-regular">
                Filter by:
              </Typography>
              {!filterValues?.added ? (
                filterByList?.map((li, i) => (
                  <div className="flex-row-ali-cen" key={`${i}_li`}>
                    <div>
                      <CustomCheckbox
                        checked={filterValues?.selectedList?.includes(li)}
                        onChange={() => onSelectFilter(li)}
                      />
                    </div>
                    <Typography className="txt-regular fs14 black mb5 mlMin15">
                      {li}
                    </Typography>
                  </div>
                ))
              ) : (
                <div>
                  <div
                    className="flex-row-ali-cen gray-back4 ph10 pv10 br10 width-fit-con mt10 cursor"
                    onClick={() => onFilterAdd(false)}
                  >
                    <AddIcon
                      sx={{ color: AppColors.appPrimary, fontSize: 15 }}
                    />
                    <Typography className="font-medium fs12 blue-color ml5">
                      Add Filter
                    </Typography>
                  </div>
                  <div>
                    {filterValues?.selectedList?.map((li) => (
                      <div className="mt20">
                        {splitRows?.includes(li) ? (
                          <div className="flex-row-between-align-center">
                            <div className="w45Per">
                              <CustomTextField
                                placeholder={getFieldName(li, "start")}
                                fullWidth
                                name={getFieldName(li, "start")}
                                label={getFieldName(li, "start")}
                                handleChange={onFilterValuesChange}
                                value={
                                  filterValues?.values?.[
                                    getFieldName(li, "start")
                                  ] ?? ""
                                }
                                mobileDate={
                                  li === "Mfg Date" || li === "Expiry Date"
                                }
                                type="number"
                              />
                            </div>
                            <div className="w45Per">
                              <CustomTextField
                                placeholder={getFieldName(li, "end")}
                                fullWidth
                                name={getFieldName(li, "end")}
                                label={getFieldName(li, "end")}
                                handleChange={onFilterValuesChange}
                                value={
                                  filterValues?.values?.[
                                    getFieldName(li, "end")
                                  ] ?? ""
                                }
                                mobileDate={
                                  li === "Mfg Date" || li === "Expiry Date"
                                }
                                type="number"
                              />
                            </div>
                          </div>
                        ) : li === "Drug Schedule" ? (
                          <Select
                            list={drugScheduleList}
                            value={filterValues?.values?.[li] ?? null}
                            handleChange={(e, value) =>
                              onFilterValuesChange({
                                target: { value, name: li },
                              })
                            }
                            name={li}
                            search
                            label={li}
                          />
                        ) : (
                          <CustomTextField
                            placeholder={li}
                            fullWidth
                            name={li}
                            handleChange={onFilterValuesChange}
                            value={filterValues?.values?.[li] ?? ""}
                            label={li}
                            type={li === "Reorder Level" ? "number" : "text"}
                            suggetions={inputSuggestionList?.includes(li)}
                            options={getSuggestionList(li)}
                          />
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {!filterValues?.added ? (
                <div className="flex1-end mt15">
                  <div>
                    <CustomButton
                      text="Add"
                      smallBtn
                      onClick={() => onFilterAdd(true)}
                    />
                  </div>
                </div>
              ) : (
                <div className="flex-row-center mt15">
                  <div>
                    <CustomButton
                      text="Reset All"
                      smallBtn
                      onClick={onFilterReset}
                      tabSelectdBtn
                    />
                  </div>
                  <div className="ml20">
                    <CustomButton
                      text="Apply Filters"
                      smallBtn
                      onClick={onApplyFilter}
                    />
                  </div>
                </div>
              )}
            </Grid>
          </Grid>
        </div>
      </CustomModal>
    </>
  );
};

export default Stock;
